import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationIT = {
  title: 'Note legali',
  subtitle: 'Informazioni ai sensi del § 5 DDG (legge tedesca sui servizi digitali)',
  serviceProvider: 'Fornitore del servizio',
  contactTitle: 'Contatto',
  addressLabel: 'Indirizzo',
  contactLabel: 'Indirizzo e-mail',
  professionalTitle: 'Informazioni sull\'azienda',
  professionLabel: 'Forma giuridica',
  businessTypeLabel: 'Tipo di attività',
  taxTitle: 'Informazioni fiscali',
  liabilityTitle: 'Note sulla responsabilità',
  contentLiabilityTitle: 'Responsabilità per i contenuti',
  contentLiability: 'In qualità di fornitore di servizi siamo responsabili, ai sensi del § 7, comma 1, DDG, dei contenuti propri presenti su queste pagine secondo le leggi generali. Ai sensi dei §§ da 8 a 10 DDG, tuttavia, in qualità di fornitore di servizi non siamo tenuti a sorvegliare le informazioni di terzi trasmesse o memorizzate, né a ricercare circostanze che indichino un\'attività illecita.',
  linkLiabilityTitle: 'Responsabilità per i link',
  linkLiability: 'La nostra offerta contiene link a siti web esterni di terzi, sui cui contenuti non abbiamo alcuna influenza. Non possiamo pertanto assumere alcuna garanzia per tali contenuti. Dei contenuti delle pagine collegate è sempre responsabile il rispettivo fornitore o gestore. Al momento dell\'inserimento del link, le pagine collegate sono state verificate per individuare eventuali violazioni di legge. In quel momento non erano riconoscibili contenuti illeciti.',
  copyrightTitle: 'Diritto d\'autore',
  copyright: 'I contenuti e le opere creati dai gestori del sito e presenti su queste pagine sono soggetti al diritto d\'autore tedesco. La riproduzione, l\'elaborazione, la diffusione e qualsiasi forma di utilizzo al di fuori dei limiti del diritto d\'autore richiedono il consenso scritto del rispettivo autore o creatore. I download e le copie di queste pagine sono consentiti esclusivamente per uso privato e non commerciale.'
};

export const localeIT = {
  nav: {
    title: 'pAIoneer Labs GmbH',
    home: 'Home',
    team: 'Team',
    events: 'Eventi',
    finance: 'IA per la finanza',
    teaching: 'Formazione',
    agenticdev: 'IDD / Agentic Coding',
    iddLegacy: 'Modernizzare il software legacy',
    iddMethod: 'Intent-Driven Development',
    veridion: 'Veridion',
    kyveil: 'Anonimizzazione',
    quantum: 'Quantum AI',
    login: 'Accedi',
    openApp: 'Apri l\'app',
    account: 'Account',
    admin: 'Admin',
    logout: 'Esci',
    languageNames: {
      en: 'Inglese',
      de: 'Tedesco',
      nl: 'Olandese',
      uk: 'Ucraino',
      fr: 'Francese',
      it: 'Italiano',
      es: 'Spagnolo',
      sv: 'Svedese',
      fi: 'Finlandese',
      ja: 'Giapponese',
      pl: 'Polacco',
      bg: 'Bulgaro'
    }
  },
  admin: {
    datalake: {
      loading: "Caricamento …",
      loadFailed: "Il data lake non è raggiungibile",
      refresh: "Aggiorna",
      generatedAt: "Aggiornato al",
      notRolled: "Quest'area non è ancora attiva nel backend. Non appena i nuovi endpoint saranno online, qui comparirà lo stato misurato.",
      loadMore: "Carica altro",
      yes: "sì",
      no: "no",
      none: "nessuno",
      close: "Chiudi",
      summaryTitle: "Due ipotesi, un banco di lavoro",
      summaryBody: "L'ipotesi dell'architettura dice: il recipiente matematico decide che cosa il modello può diventare — vive nella pagina del paper LLM. L'ipotesi dei dati dice: solo dati di addestramento collegati e verificati riempiono quel recipiente — questa pagina la serve. L'autopilota riempie il patrimonio di dati in continuo, avvia l'addestramento appena il piano dei dati del paper è raggiunto in ogni area, in tedesco e in inglese, misura il risultato con la suite di benchmark e pubblica il modello in privato su HuggingFace. Ogni numero qui è misurato o contrassegnato come valore configurato.",
      summaryArchButton: "All'ipotesi dell'architettura (paper LLM)",
      apTitle: "Autopilota",
      tpTitle: "Percorso verso l'avvio dell'addestramento",
      tpSubtitle: "Dove si trova ora il pilota automatico: ogni passo fino all'addestramento in corso, con stato, tempo e avanzamento.",
      tpNow: "Ora",
      tpStep: "Passo",
      tpOf: "di",
      tpSince: "da",
      tpFor: "in corso da",
      tpHeartbeat: "ultimo segnale di vita",
      tpDone: "fatto",
      tpRunning: "in corso",
      tpWaiting: "in attesa",
      tpFailed: "fallito",
      tpSkipped: "saltato",
      tpProgress: "Avanzamento",
      tpRows: "righe",
      tpRate: "al secondo",
      tpRemaining: "tempo residuo stimato",
      tpEstimateNote: "stima dai contatori misurati",
      tpPhaseReading: "lettura di un pacchetto di dati",
      tpPhaseAdmission: "ammissione (duplicati, entropia)",
      tpPhaseEncoding: "tokenizzazione",
      tpNoTiming: "Questa versione del motore non riporta ancora i tempi.",
      tpBlockers: "Blocchi ed errori",
      tpNone: "Nessun blocco.",
      trTitle: "Esecuzione di addestramento (live)",
      trSubtitle: "Letto direttamente dalla directory di esecuzione del trainer: funziona anche mentre il worker si riavvia.",
      trNoRun: "Ancora nessuna esecuzione di addestramento con dati di avanzamento.",
      trStateTraining: "in addestramento",
      trStateStarting: "in avvio",
      trStateFinished: "terminato",
      trStateSilent: "silenzioso da {age}",
      trStep: "Passo",
      trOf: "di",
      trRemaining: "Tempo rimanente (stima dalla velocità misurata)",
      trSecondsPerStep: "s per passo",
      trProgress: "Avanzamento dei passi pianificati",
      trRun: "Esecuzione",
      trResumed: "ripresa dal passo {step}",
      trVersion: "Versione dei dati di addestramento",
      trModel: "Modello",
      trTokensPerSecond: "Token/s",
      trTokensSeen: "Token visti",
      trVram: "Memoria GPU",
      trCap: "limite",
      trLastHeartbeat: "Ultimo heartbeat",
      trAgo: "{age} fa",
      trShardReads: "Letture di shard in locale / tramite il worker",
      trLossTitle: "Andamento della loss",
      trLossTotal: "Totale",
      trLossNtp: "Token successivo",
      trLossMtp: "Multi-token",
      trChartEmpty: "Nessun passo segnalato finora.",
      trAxisNote: "Orizzontale: passo di addestramento, verticale: loss (logaritmo naturale). Passa il mouse sulla curva per vedere i valori di un passo.",
      trValue: "Valore",
      trCurrentValue: "attuale",
      trPoints: "{count} punti di misura in totale",
      trStages: "Fasi del curriculum",
      trStageFoundation: "Fondamenta (testo grezzo)",
      trStageCapability: "Capacità",
      trStageAnneal: "Anneal",
      trStageCurrent: "in corso",
      trStageDone: "completata",
      trStageAhead: "in arrivo",
      trShards: "shard",
      trRows: "righe",
      trCheckpoint: "Checkpoint più recente",
      trCheckpointNone: "ancora nessuno",
      trCheckpoints: "Checkpoint completi su disco",
      trCheckpointEvery: "ogni {minutes} min",
      trKernels: "Kernel attivi",
      trDeviations: "Deviazioni",
      trBlockStorage: "Copia nel block storage",
      trBlockStorageNone: "ancora nessuna: la prima segue il primo checkpoint",
      trUploading: "caricamento in corso: passo {step}",
      treeCkRun: "Esecuzione di addestramento",
      treeCkCopy: "Checkpoint nel block storage, copiato {time}",
      treeCkLocal: "Checkpoint sul disco del server",
      treeCkUploading: "in copia verso il block storage",
      trKpiProgress: "Avanzamento",
      trKpiTokens: "Token",
      trKpiThroughput: "Throughput",
      trKpiLoss: "Loss",
      trKpiLr: "Learning rate",
      trKpiGpu: "Memoria GPU",
      trEndAt: "fine circa {time}",
      trSeenPlanned: "visti / pianificati",
      trBest: "migliore {value}",
      trHourAgo: "{value} rispetto a 1 h fa",
      trPerplexity: "perplessità {value}",
      trPhaseWarmup: "riscaldamento",
      trPhaseCosine: "decadimento coseno",
      trPhaseStable: "fase stabile",
      trPhaseDecay: "raffreddamento",
      trKpiEpoch: "Epoca",
      trEpochValue: "{epoch} di {epochs}",
      trPlanTitle: "Piano di addestramento",
      trPlanExplain: "Riscaldamento fino al tasso di apprendimento massimo, poi costante per quattro epoche miste del corpus; la fase di raffreddamento addestra sulla miscela di qualità più alta (campioni di capacità, testi da manuale, anneal) e porta il tasso di apprendimento a zero.",
      trPlanPhase: "Fase",
      trPlanStableSteps: "Passi pianificati della fase stabile",
      trPlanDecay: "Raffreddamento",
      trPlanDecayAhead: "dal passo {step} · tra circa {time}",
      trPlanDecayAheadNoTime: "dal passo {step}",
      trPlanDecayRunning: "dal passo {step} · {steps} passi fino a tasso di apprendimento zero",
      trPlanTokensPerStep: "Token per passo di ottimizzazione",
      trPlanTokensPerStepValue: "{tokens} ({accum} micro-batch)",
      trPlanRecompute: "Ricalcolo delle attivazioni",
      trPlanRecomputeOn: "attivo – misurato più veloce con un micro-batch più grande",
      trPlanRecomputeOff: "disattivo – misurato più veloce senza",
      trPlanFim: "Documenti in forma fill-in-the-middle finora",
      tbTitle: "Programma manuali",
      tbSubtitle: "Testi di foundation riscritti da modelli insegnanti come testo da manuale; ogni numero e ogni nome proprio deve comparire nella fonte.",
      tbTokens: "Token da manuale",
      tbTokensSub: "{pct} % dell’obiettivo di {target}",
      tbSamples: "Riscritture ammesse",
      tbJobs: "Job completati",
      tbTeacher: "Token insegnante per token da manuale",
      tbCost: "Costo per milione di token da manuale",
      tbCostNone: "il gateway non riporta costi; si contano i token insegnante",
      tbExplain: "Procede accanto all’addestramento; le epoche successive e il raffreddamento leggono ciò che è sigillato fino ad allora.",
      trThroughputTitle: "Throughput (token/s)",
      trCurriculumTitle: "Curriculum",
      trStageTokens: "{tokens} token",
      trStageBegins: "inizia al passo {step}",
      trPlanWarningLabel: "Attenzione",
      trPlanWarning: "L'esecuzione termina dopo {max} passi nella fase «{stage}»: i dati delle capacità iniziano solo al passo {cap}. Un passaggio completo richiederebbe {steps} passi (≈ {days} giorni).",
      trPlanOk: "I passi pianificati arrivano fino alla fase «{stage}».",
      trCheckpointsTitle: "Checkpoint",
      trNextCheckpoint: "Prossimo checkpoint",
      trInSpan: "tra {span}",
      trResumes: "Ripresa",
      trNoResume: "nessuna",
      trConfig: "Configurazione",
      trHealth: "Stato",
      trMicroBatch: "Micro-batch / token per passo",
      trSeqLen: "Lunghezza della sequenza",
      trLrPlan: "Piano del learning rate",
      trLrPlanValue: "picco {lr}, riscaldamento {warmup} passi, coseno fino al passo {max}",
      trSpikes: "Picchi di loss (ultima ora)",
      trProgressSub: "passo {step} di {max} · in addestramento da {elapsed}",
      trTokensSub: "su {planned} pianificati",
      trPathTrainingDetail: "{pct} % · passo {step} di {max} · fine circa {end}",
      trReadinessRunning: "L'addestramento è in corso: {pct} % completato (passo {step} di {max}), loss {loss}, fine circa {end}.",
      tdvDraftsHistory: "Bozze più vecchie, mai sigillate ({count})",
      runsHistory: "Esecuzioni interrotte e fallite ({count})",
      trAxisStep: "Passo di addestramento",
      trAxisLoss: "Loss (logaritmo naturale)",
      trCountdown: "{d} g {h} h {m} min {s} s",
      trTimerWaiting: "Il timer compare dopo le prime misurazioni.",
      trTimerStageEnds: "La fase «{stage}» termina tra",
      trTimerAt: "alle {time}",
      trTimerNext: "Poi «{stage}»: {span}, da {time}",
      trTimerRunEnds: "L'esecuzione termina tra {span} (alle {time})",
      trStepTimeSub: "{wall} s per passo misurati · calcolo {compute} s",
      trEtaTitle: "Tempo residuo dalla durata misurata del passo",
      trEtaEpochEnds: "L'epoca {epoch} di {epochs} termina tra",
      trEtaEpochAt: "alle {time} (passo {step})",
      trEtaNextEpoch: "Epoca {epoch}: da {time} (passo {step})",
      trEtaDecay: "La fase di raffreddamento inizia tra {span} (alle {time}, passo {step})",
      trEtaBasis: "Base: {wall} s per passo, media degli ultimi {n} passi senza {pauses} pause (riavvio, stallo); tempo di calcolo secondo il trainer {compute} s per passo.",
      devTitle: "Deviazioni dal progetto",
      devNone: "Nessuna deviazione: l'esecuzione segue il progetto per intero.",
      devPlanned: "pianificato",
      devLimit: "limitazione",
      devSeqLen: "Lunghezza del contesto",
      devSeqLenText: "Addestrato con {trained} token di contesto invece dei {spec} previsti dal progetto. Il contesto lungo arriva in una fase successiva.",
      devFim: "Riempimento lacune (FIM)",
      devFimText: "L'obiettivo di riempimento lacune ({rate} % dei blocchi) è dichiarato nel progetto ma non è ancora attivo in questa esecuzione.",
      devTermination: "Sonda di terminazione",
      devTerminationText: "La sonda di terminazione non è un obiettivo di addestramento ma una modalità a sé dopo l'addestramento; gira più tardi su un checkpoint finito.",
      devDecision: "Obiettivo decisionale",
      devDecisionText: "L'obiettivo decisionale è attivo, ma nelle fasi post-addestramento di questa esecuzione non sono arrivati marcatori di decisione.",
      devKernelOff: "Accelerazione disattivata",
      devKernelUnverifiedText: "Il kernel «{kernel}» non è stato verificato dalla sonda e gira come calcolo standard.",
      devKernelUnavailableText: "Il kernel «{kernel}» non è disponibile su questa scheda e gira come calcolo standard.",
      devKernelFellBackText: "Il kernel «{kernel}» è tornato al calcolo standard durante l'esecuzione ({reason}).",
      devOptimizer: "Ottimizzatore",
      devOptimizerText: "Gli stati dell'ottimizzatore sono in bfloat16 invece che a 8 bit (bitsandbytes non disponibile): più memoria, stessa matematica.",
      devScale: "Dimensione del modello",
      devScaleText: "Il modello è istanziato al {scale} % della dimensione del progetto perché la dimensione piena non entrava nella memoria misurata.",
      devMediaHeads: "Teste media",
      devMediaHeadsText: "Le teste immagine/audio non sono addestrate perché i dati non contengono token media — previsto per un filone di testo.",
      devVision: "Percorso visivo",
      devVisionText: "Il percorso visivo è costruito ma ha addestrato con zero immagini perché i dati non ne contengono.",
      devOther: "Altro",
      trStageShare: "{pct} % di questa fase completato",
      cap_tool_calling: "Chiamate di strumenti",
      cap_deep_reasoning: "Ragionamento profondo",
      cap_software_engineering: "Sviluppo software",
      cap_office_finance: "Ufficio e finanza",
      cap_doc_understanding: "Comprensione dei documenti",
      tpExplainThresholds: "Per ogni capacità del filone scelto devono esserci abbastanza esempi verificati nel data lake. Obiettivo e misura stanno qui per capacità.",
      tpThresholdsDetail: "{met} capacità su {total} hanno raggiunto l'obiettivo",
      tpThresholdRow: "{measured} esempi",
      tpForeignThresholds: "Non per questo filone: {list} — appartiene a un altro filone e non blocca nulla.",
      tpStepTokenizerReleaseExplain: "Il tokenizer trasforma il testo in numeri. Viene fissato una volta e comunicato all'architettura, così dati e modello parlano la stessa lingua.",
      tpStepTokenizeTdvExplain: "Tutti gli esempi verificati vengono tradotti in sequenze numeriche con il tokenizer fissato.",
      tpStepTokenizeCorpusExplain: "Tutto il testo grezzo del data lake viene tradotto in sequenze numeriche: la massa per le fondamenta.",
      tpStepTdvCreateExplain: "Da tutti i dati tokenizzati si compone una versione fissa dei dati di addestramento (TDV), con curriculum e massa di token misurata.",
      tpStepTdvSealExplain: "La versione diventa immutabile e viene copiata con la sua descrizione nel block storage.",
      tpStepCompatExplain: "Dodici regole verificano che versione e architettura combacino (tokenizer, lunghezza del contesto, obiettivi, memoria). Tutte devono essere verdi.",
      tpStepVramExplain: "Misura sulla scheda se c'è abbastanza memoria GPU libera per il fabbisogno dichiarato.",
      tpVramDetail: "{free} GB liberi, {need} GB necessari",
      tpStepTrainStartExplain: "L'autopilota avvia l'esecuzione non appena tutte le condizioni sono soddisfatte.",
      tpStepTrainingExplain: "L'esecuzione si addestra da sola con checkpoint ogni 30 minuti e riprende da sé dopo ogni interruzione. Dettagli nella pagina «Addestramento e pubblicazione».",
      tpVramRunning: "scheda in uso dall'addestramento in corso ({need} GB necessari); soddisfatto all'avvio",
      trPathTrainingDetailNoEnd: "{pct} % · passo {step} di {max}",
      srTitle: "Prontezza dei dati per filone del modello",
      srSubtitle: "Mentre un filone si addestra, il data lake continua a preparare i dati degli altri — fino alla loro versione sigillata, senza avvio dell'addestramento.",
      srTrainingNow: "in addestramento",
      srSelected: "selezionato",
      srDataReady: "dati pronti",
      srPreparing: "in preparazione",
      srModalities: "ingresso: {in} · uscita: {out}",
      srThresholds: "obiettivi: {met} su {total} raggiunti",
      srCorpus: "Corpus tokenizzato",
      srCorpusValue: "{tokens} token in {shards} pacchetti di dati",
      srVersion: "Versione più recente",
      srNoVersion: "ancora nessuna",
      srLacking: "Manca ancora",
      srLacksNothing: "nulla: la versione attende il suo filone",
      srLackThresholds: "obiettivi non raggiunti",
      srLackCodec: "codec immagine/audio non rilasciato",
      srLackTokenizer: "tokenizer non comunicato",
      srLackVersion: "nessuna versione sigillata",
      srSelectedNote: "Questo filone si addestra ora; il suo percorso sta sopra.",
      srSelectedIdleNote: "Questo filone è selezionato per il prossimo addestramento; il suo percorso sta sopra.",
      srUnselectedNote: "Questo filone non avvia addestramenti finché un altro è selezionato; i suoi dati vengono comunque preparati per intero.",
      modText: "testo",
      modImage: "immagine",
      modAudio: "audio",
      modVideo: "video",
      tpStepThresholds: "Raggiungere gli obiettivi",
      tpStepPlan: "Raggiungere il piano dei dati del paper",
      tpExplainPlan: "Il paper stabilisce quanti token unici e verificati servono a ogni area. Tedesco e inglese ne portano ciascuno almeno la metà; il codice conta senza lingua. Si contano i token ammessi dopo la rimozione dei duplicati, non la stima grezza.",
      tpPlanDetail: "{met} aree su {total} raggiunte",
      tpPlanRowLang: "{have} / {target} · tedesco {de} / {half} · inglese {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "aperto: {langs}",
      tpLangDe: "tedesco",
      tpLangEn: "inglese",
      tpPlanProvisional: "Contato provvisoriamente con il tokenizer precedente; decide quello appena addestrato.",
      tpStepOwnTokenizer: "Tokenizer proprio del filone",
      tpStepOwnTokenizerExplain: "Il filone si addestra con un tokenizer proprio, appreso su un corpus equilibrato che include codice. Solo nei suoi token il piano dei dati conta in via definitiva.",
      tpPlanCat_knowledge: "Conoscenza",
      tpPlanCat_code: "Codice",
      tpPlanCat_mathematics: "Matematica",
      tpPlanCat_domain: "Testi specialistici",
      tpPlanCat_textbook: "Libro di testo",
      tpPlanCat_agentic: "Esempi agentici",
      tpPlanFlow: "afflusso {rate} all'ora",
      tpPlanEtaDays: "ancora circa {n} giorni",
      tpPlanEtaHours: "ancora circa {n} ore",
      tpPlanNoFlow: "nessun afflusso nelle ultime 24 ore",
      tpPlanBinding: "collo di bottiglia",
      tpBind_download: "download",
      tpBind_allowance: "la quota giornaliera del block storage",
      tpBind_ingest: "ingestione",
      tpBind_teachers: "modelli insegnanti",
      thrPlanTitle: "Esempi per capacità (misurati)",
      thrPlanNote: "Gli obiettivi di questo filone li fissa il suo paper: il piano dei dati per area, in tedesco e in inglese, nel percorso verso l'avvio dell'addestramento. Le soglie per capacità valgono solo per i filoni senza piano dei dati; qui si legge cosa contiene ogni capacità, misurato.",
      thrPlanRow: "{samples} esempi · {tokens} token",
      srDataPlan: "Piano dei dati del paper: {met} aree su {total} raggiunte",
      srLackDataPlan: "piano dei dati non raggiunto",
      srPlanOpen: "aperto: {areas}",
      tpBind_source: "nessuna fonte in questa lingua",
      tpBind_paused: "download in pausa",
      tdvPlanEmpty: "Ancora nessuna versione dei dati della specifica attiva. L'autopilota la costruisce e la sigilla appena il piano dei dati del paper è raggiunto.",
      compatPlanNone: "Ancora nessun controllo: la versione della specifica attiva viene controllata quando viene sigillata.",
      mixPlanTitle: "Miscela secondo il paper",
      mixPlanNote: "Ogni passo di addestramento attinge alle aree in queste quote fisse; la fase di decadimento porta la quota di alta qualità fino alla metà. Gli obiettivi di miscela per capacità valgono solo per i filoni senza piano dei dati.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Situazione",
      sitSubtitle: "Dove si trova l'addestramento a colpo d'occhio: cosa manca ancora in ogni area del paper, cosa è in corso e cosa viene dopo.",
      sitHeadlineDays: "L'addestramento può partire al più presto tra circa {time}; il più lento è {area} (collo di bottiglia: {bottleneck}).",
      sitHeadlineBlocked: "Così il piano dei dati non si raggiunge: {items} non ha una fonte. Ci si sta lavorando: cercare dataset aperti o tradurre con verifica.",
      sitHeadlineReached: "Il piano dei dati è raggiunto; seguono il tokenizer, la nuova tokenizzazione, il sigillo e i controlli.",
      sitHeadlineUnknown: "L'afflusso del resto non è ancora misurato.",
      sitHold: "L'avvio è inoltre sospeso finché ogni componente non è verificato.",
      sitArea: "Area",
      sitTotal: "Totale",
      sitFlow: "Afflusso",
      sitLeft: "Manca",
      sitBottleneck: "Collo di bottiglia",
      sitNoLanguage: "senza lingua",
      sitNoSource: "nessuna fonte",
      sitReached: "raggiunto",
      sitDays: "{n} giorni",
      sitHours: "{n} h",
      sitPerHour: "{value} all'ora",
      sitPerHourTokens: "{value} token all'ora",
      sitRunningTitle: "Cosa è in corso",
      sitDownloads: "Download",
      sitIngest: "Elaborazione in frammenti di testo",
      sitTokenize: "Tokenizzazione",
      sitGenerate: "Generazione dai modelli insegnanti",
      sitIdle: "a riposo",
      sitNextTitle: "Cosa viene dopo",
      sitNextSteps: "Addestrare il tokenizer con codice → ritokenizzare l'intero corpus → sigillare la versione → controlli → avvio dell'addestramento",
      sitProvisional: "Le quantità sono contate provvisoriamente con il tokenizer precedente; quello appena addestrato conta in modo definitivo.",
      tpPlanSeeSituation: "Aree, lingue e tempi rimanenti sono nella situazione qui sopra.",
      sitHeadlineBlocks: "L'addestramento non può ancora partire: mancano componenti che devono ancora essere costruiti ({items}). Nel frattempo i dati crescono.",
      sitDuration: "Durata dell'addestramento: circa {days} giorni per {budget} token ai {rate} token al secondo misurati sulla stessa rete.",
      sitBlocksTitle: "Componenti dell'addestramento",
      sitStateNotBuilt: "non ancora costruito",
      sitStateWaiting: "attende",
      sitStateReady: "pronto",
      sitBlockWaitsFor: "attende: {items}",
      sitBenchProgress: "{made} di {total} compiti verificati",
      sitBlockParts: "costruito: {built} · aperto: {open}",
      part_graph_bundles: "documenti collegati",
      part_repository_bundles: "repository completi",
      part_long_context: "contesto lungo",
      part_fine_tuning: "messa a punto",
      part_reinforcement_learning: "apprendimento per rinforzo",
      part_real_folding: "ripiegamento reale del contesto",
      sitBlock_data: "Dati secondo il piano del paper",
      sitBlock_tokenizer: "Tokenizer con codice",
      sitBlock_bench: "Suite di benchmark del paper",
      sitBlock_trainer: "Addestratore: fasi di finestra, budget fisso, miscela fissa",
      sitBlock_bundles: "Pacchetti: documenti collegati e repository completi",
      sitBlock_post_training: "Post-addestramento: contesto lungo, fine-tuning, apprendimento per ricompensa",
      tpStepTokenizerRelease: "Rilascio del tokenizer",
      tpStepTokenizeTdv: "Tokenizzare gli esempi di addestramento",
      tpStepTokenizeCorpus: "Tokenizzare il corpus",
      tpStepTdvCreate: "Creare la versione dei dati",
      tpStepTdvSeal: "Sigillare la versione dei dati",
      apAfterSealLabel: "Continua automaticamente dopo la sigillatura",
      apAfterSealOn: "ON",
      apAfterSealOff: "OFF",
      apAfterSealConfirmOn: "Continuare automaticamente dopo la sigillatura? Il percorso verso l'avvio dell'addestramento prosegue allora senza pausa: verifica di compatibilità, verifiche GPU e avvio dell'addestramento.",
      apAfterSealConfirmOff: "Fermarsi di nuovo dopo la sigillatura? L'autopilota si mette allora in pausa per la revisione una volta sigillata la versione dei dati.",
      apAfterSealTurnedOn: "Il percorso verso l'avvio dell'addestramento prosegue automaticamente dopo la sigillatura.",
      apAfterSealTurnedOff: "L'autopilota si ferma dopo la sigillatura.",
      apAfterSealWaiting: "Versione dei dati sigillata – l'autopilota è in pausa per la revisione.",
      apAfterSealStep: "Revisione della versione dei dati sigillata",
      apAfterSealHint: "Dopo la sigillatura tutti i dati sono elaborati nel block storage. Con l'interruttore spento l'autopilota si ferma lì per la revisione; acceso, il percorso prosegue automaticamente.",
      tpStepCompat: "Controllo di compatibilità",
      tpStepVram: "Test VRAM",
      tpStepTrainStart: "Avvio dell'addestramento",
      tpStepTraining: "Addestramento in corso",
      apSubtitle: "Un interruttore per l'intero ciclo: raccogliere, elaborare e collegare i dati, generare esempi, addestrare appena il piano dei dati del paper è raggiunto, misurare con benchmark e pubblicare in privato. Ogni blocco viene nominato invece che nascosto.",
      apOn: "Autopilota ATTIVO",
      apOff: "Autopilota SPENTO",
      apTurnOn: "Attivare l'autopilota",
      apTurnOff: "Spegnere l'autopilota",
      apConfirmOn: "Attivare l'autopilota? Completa i dati in modo continuo fino alla versione dei dati sigillata; poi si mette in pausa per la revisione, a meno che «Continua automaticamente dopo la sigillatura» sia attivo.",
      apConfirmOff: "Spegnere l'autopilota? Il lavoro in corso termina in modo controllato; nulla viene scartato.",
      apEnabled: "Autopilota attivato",
      apDisabled: "Autopilota spento",
      apPause: "Metti in pausa",
      apResume: "Riprendi",
      apResumed: "Autopilota ripreso",
      apPausedNote: "Autopilota in pausa",
      apPausedPill: "in pausa",
      apPhaseLabel: "Fase",
      apPhaseSince: "da {time}",
      apCycleId: "Ciclo",
      apBlockedLabel: "Bloccato",
      apCycleTitle: "Avanzamento del ciclo in corso",
      apCycleEmpty: "Nessun ciclo attivo.",
      colPhase: "Fase",
      colPending: "In attesa",
      colRunning: "In corso",
      colDone: "Completato",
      colFailed: "Fallito",
      thrTitle: "Soglie per capacità",
      thrSubtitle: "A partire da questi volumi l'autopilota sigilla una versione di dati di addestramento e avvia l'addestramento; le barre mostrano l'avanzamento misurato.",
      thrMet: "raggiunta",
      thrNotMet: "aperta",
      thrDefault: "standard preimpostato",
      thrForeign: 'non per il filone scelto',
      staleSince: 'Il worker non risponde al momento — ultimo stato misurato del',
      staleHint: 'L\'autopilota continua; la vista si aggiorna appena il worker risponde di nuovo.',
      idxTitle: 'Indice vettoriale e deduplicazione',
      idxSubtitle: 'L\'indice HNSW proprio del lago per il collegamento del grafo e la rimozione misurata degli shard di chunk duplicati.',
      idxConfigured: 'Indice configurato',
      idxReachable: 'Indice raggiungibile',
      idxPoints: 'Punti dell\'indice',
      idxBackfill: 'Riempimento dalla tabella degli embedding',
      idxBackfillDone: 'completato',
      idxBackfillOpen: 'in corso / aperto',
      ddLastPass: 'Ultimo passaggio di deduplicazione',
      ddChecked: 'asset verificati',
      ddDropped: 'shard duplicati rimossi',
      ddRows: 'righe di chunk rimosse',
      ddRemaining: 'candidati rimanenti',
      ddNone: 'nessun passaggio ancora',
      gsTitle: 'Fasi del grafo',
      gsSubtitle: 'Le fasi teacher del grafo — embedding ed estrazione delle affermazioni — servono alla sintesi di esempi derivata dal grafo; perciò prendono i chunk in ampiezza attraverso gli asset, in ordine di rango: rango 0 i documenti del proprietario e le importazioni da strumenti, rango 1 la massa di sapere esperto (scienza, ingegneria, libri, ragionamento, German Commons, Wikipedia), rango 2 il testo generale (Wikisource, Gutenberg, corpus web, trascrizioni), rango 3 il codice (solo embedding, mai estrazione di affermazioni). La massa di base raggiunge il corpus di token senza un passaggio teacher.',
      gsMeasuredAt: 'Misurato alle',
      gsRanksTitle: 'Ordine dei ranghi',
      gsRanksEmpty: 'Nessun piano dei ranghi ancora riportato.',
      gsColRank: 'Rango',
      gsColLabel: 'Classe di fonte',
      gsColSources: 'Fonti',
      gsColAssets: 'Asset',
      gsColPendingExtract: 'Estrazione in attesa',
      gsColPendingEmbed: 'Embedding in attesa',
      gsRankOwner: 'Documenti del proprietario e importazioni da strumenti',
      gsRankExpert: 'Massa di sapere esperto',
      gsRankGeneral: 'Testo generale',
      gsRankCode: 'Codice (solo embedding)',
      gsRankShort: 'rango {n}',
      gsLoopsTitle: 'Ultimo giro di ogni ciclo',
      gsColLoop: 'Ciclo',
      gsColSource: 'Fonte',
      gsColChunks: 'Chunk elaborati',
      gsColClaims: 'Affermazioni',
      gsColEdges: 'Archi',
      gsColSeconds: 'Secondi',
      gsColLast: 'Ultimo giro',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Estrazione delle affermazioni',
      gsLoopLink: 'Collegamento',
      gsUngrounded: '{n} non fondate',
      gsNoRound: 'nessun giro ancora',
      gsClaims: 'Affermazioni in totale',
      gsAssetsWithClaims: 'Asset con affermazioni',
      gsDangling: 'Nodi chunk orfani',
      gsStuck: 'Asset bloccati (in elaborazione senza ingest attivo)',
      gsConcurrency: "Parallelismo dell'estrazione",
      gsOrphansLast: 'Ultimo passaggio di pulizia',
      gsOrphansNone: 'nessun passaggio ancora',
      gsOrphansStatusCleaned: 'pulito',
      gsOrphansDropped: 'nodi rimossi',
      gsOrphansRemaining: 'rimanenti',
      gsOrphansHint: "Niente da fare qui: l'autopilota pianifica da sé un passaggio di pulizia limitato finché esistono nodi chunk senza shard. Il riepilogo mostra l'ultimo passaggio.",
      thrSamplesBar: "Esempi",
      thrTokensBar: "Token (stimati)",
      thrNoMinimum: "misurato, nessun minimo",
      thrEditTitle: "Modifica soglie",
      thrEditSubtitle: "Il salvataggio sostituisce integralmente tutte le soglie; gli standard preimpostati valgono solo finché qui non vengono impostati valori propri.",
      thrMinSamples: "Esempi min.",
      thrMinTokens: "Token min. (stimati)",
      thrEnabled: "attiva",
      thrAdd: "Aggiungi riga",
      thrSave: "Salva soglie",
      thrSaved: "Soglie salvate",
      thrEmpty: "Nessuna soglia definita finora — senza soglie attive l'autopilota non sigilla nulla e lo segnala come blocco.",
      capability: "Capacità",
      modSignature: "Firma",
      removeRow: "Rimuovi",
      budgetsTitle: "Budget giornalieri",
      budgetsSubtitle: "Consumo contro limite per ambito e giorno — i budget limitano le chiamate insegnante ed embedding.",
      budgetScope: "Ambito",
      budgetDay: "Giorno",
      budgetSpent: "Consumato",
      budgetCap: "Limite",
      budgetsEmpty: "Nessun budget segnalato.",
      eventsTitle: "Eventi",
      eventsSubtitle: "Che cosa l'autopilota ha fatto o segnalato per ultimo, il più recente per primo.",
      eventsEmpty: "Ancora nessun evento.",
      storageTitle: "Archiviazione cloud",
      storageSubtitle: "La connessione al Block Storage e l'inizializzazione della struttura delle cartelle — ripetibile senza effetti collaterali.",
      connect: "Collega Block Storage",
      backendLabel: "Backend del cold store",
      backendBlockStorage: "Block Storage",
      backendLocal: "Archiviazione locale",
      connectedLabel: "Connessione",
      connectedYes: "collegato",
      connectedNo: "non collegato",
      accountLabel: "Account",
      signinValidUntil: "Accesso valido fino al",
      oauthClientLabel: "Client OAuth",
      clientConfigured: "configurato",
      clientNotConfigured: "non configurato",
      bootstrapRun: "Inizializza struttura",
      bootstrapDone: "Inizializzazione eseguita",
      bootstrapReportTitle: "Ultima esecuzione",
      bootstrapNoRun: "In questa sessione non è ancora stato eseguito alcun bootstrap.",
      bootstrapLine: "Cartelle create: {folders} · file nel cold store: {files} · ripetizione senza modifiche: {idempotent}",
      treeTitle: "Albero delle cartelle",
      treeSubtitle: "L'albero è una specifica versionata: qui si definiscono le cartelle, l'autopilota può solo aggiungere. Le cartelle motore protette e le cartelle non vuote vengono rifiutate dal motore con motivazione. Nel Block Storage si cancella solo secondo regole fisse, per esempio le copie di checkpoint più vecchie (le due più recenti restano); durante un download completo cancellazioni e sovrascritture attendono che finisca.",
      treeActiveVersion: "Versione attiva v{version}",
      treePath: "Percorso",
      treePurpose: "Scopo",
      treeCreatedBy: "Creato da",
      treeShards: "Shard",
      treeBytes: "Dimensione",
      treeActions: "Azioni",
      treeRetire: "Dismetti",
      treeRetired: "Cartella dismessa",
      treeAddFolder: "Aggiungi cartella",
      treeFolderAdded: "Cartella creata",
      treeVersionsTitle: "Versioni",
      treeEmpty: "Nessuna cartella definita finora.",
      treePlanned: "Pianificato — specifica dell'albero v{version}",
      treeFiles: "File",
      treeSizesMeasured: "Dimensioni misurate {measured}; le cartelle che il catalogo non registra sono state contate nel Block Storage l'ultima volta {walked}. 1 GB = 10⁹ byte.",
      treeSizesNoWalk: "Dimensioni misurate {measured}; le cartelle che il catalogo non registra non sono ancora state contate. 1 GB = 10⁹ byte.",
      treeExpand: "Mostra {count} sottocartelle",
      treeCollapse: "Nascondi le sottocartelle",
      treeShowMore: "Mostra altre {count} cartelle",
      treeSourceCatalog: "Dal catalogo: contati gli oggetti che si trovano davvero nel Block Storage",
      treeSourceWalk: "Contato durante la scansione del Block Storage",
      bsUsageTitle: "Spazio del Block Storage",
      bsUsageSubtitle: "Spazio occupato, limite e spazio libero dell'account Block Storage e la quota del data lake; i valori hanno al massimo dieci minuti. 1 GB = 10⁹ byte.",
      bsUsed: "Occupato",
      bsLimit: "Limite",
      bsFree: "Libero",
      bsNoLimit: "senza limite fisso",
      bsTrash: "Nel cestino",
      bsLake: "Di cui data lake",
      bsLakeLine: "{size} in {files} file · {share} dello spazio occupato",
      bsMeasuredAt: "Misurato",
      bsNotConnected: "Il Block Storage non è collegato; lo spazio compare non appena la connessione è attiva.",
      bsBarLake: "Data lake",
      bsBarOther: "Resto dell'account",
      bsDlTitle: "Download completo",
      bsDlSubtitle: "Scarica l'intero Block Storage file per file nella stessa struttura di cartelle, senza archivio. Finché è in corso vale la modalità di protezione: cancellazioni e sovrascritture dei file registrati attendono che finisca; i nuovi file continuano a essere scritti e non fanno parte di questo download. Un addestramento in corso non viene mai rallentato.",
      bsDlButton: "Scarica l'intero Block Storage",
      bsDlFolderHint: "Si sceglie una volta una cartella di destinazione; lì vengono create le sottocartelle. I file già completi vengono saltati, quelli interrotti ripresi dalla loro lunghezza.",
      bsDlScriptHint: "Questo browser non può scrivere cartelle. Si riceve uno script di download che crea la stessa struttura di cartelle e scarica ogni file con possibilità di ripresa.",
      bsDlWindowsNames: "I caratteri che Windows non ammette nei nomi (come «>») compaiono nella cartella di destinazione come codice %, per esempio %3E.",
      bsDlActiveNote: "Un download è in corso dal {time}. Il pulsante in alto lo prosegue in questo browser; i file completi vengono saltati.",
      bsDlBuilding: "L'elenco dei file è in preparazione: finora {files} file, {size}.",
      bsDlManifest: "Caricamento dell'elenco dei file: {done} di {total} voci.",
      bsDlFolder: "Cartella di destinazione",
      bsDlFiles: "File",
      bsDlData: "Dati",
      bsDlOf: "{done} di {total}",
      bsDlRate: "Velocità",
      bsDlEta: "Tempo residuo",
      bsDlEtaUnknown: "in calcolo",
      bsDlCurrent: "In caricamento",
      bsDlSkipped: "{count} già completi, saltati",
      bsDlFailed: "{count} file non riusciti",
      bsDlPausedNote: "In pausa. Alla ripresa i file iniziati proseguono dalla loro lunghezza; la modalità di protezione resta finché questa pagina è aperta.",
      bsDlPause: "Pausa",
      bsDlContinue: "Riprendi",
      bsDlRetryFailed: "Riscarica i file non riusciti",
      bsDlFinish: "Concludi",
      bsDlStop: "Interrompi",
      bsDlStateBuilding: "elenco file in preparazione",
      bsDlStateRunning: "download in corso",
      bsDlStatePaused: "in pausa",
      bsDlStateIncomplete: "incompleto",
      bsDlStateScript: "script pronto",
      bsDlStateFinished: "concluso",
      bsDlStateStopped: "terminato",
      bsDlStateActive: "attivo",
      bsDlFinished: "Tutti i {files} file ({size}) sono nella cartella di destinazione; il download è concluso.",
      bsDlFinishedNote: "Il download è concluso; le cancellazioni e sovrascritture trattenute vengono eseguite ora.",
      bsDlStopped: "Il download è interrotto; le cancellazioni e sovrascritture trattenute vengono eseguite ora. I file già scaricati restano.",
      bsDlEnded: "Il server ha terminato il download, per esempio dopo trenta minuti senza segni di vita. Un nuovo clic lo riavvia; i file completi vengono saltati.",
      bsDlSession: "L'accesso è scaduto. Accedere di nuovo; poi il pulsante in alto prosegue il download.",
      bsDlDiskFull: "Nella cartella di destinazione non c'è più spazio. Liberare spazio e poi riprendere.",
      bsDlPickFailed: "Non è stato possibile aprire la cartella di destinazione.",
      bsDlScriptPosix: "Script per Linux e macOS",
      bsDlScriptWindows: "Script per Windows",
      bsDlScriptRun: "Salvare lo script nella cartella di destinazione e avviarlo lì: su Windows con un doppio clic sul file .cmd o dal prompt dei comandi, su Linux e macOS nel terminale con «sh <file>».",
      bsDlScriptKeyValid: "La chiave nello script vale fino al {time}, solo per questo download e solo in lettura.",
      bsDlScriptHeartbeat: "Finché questa pagina è aperta, comunica al server che il download è ancora in corso. Quando lo script ha finito, fare clic su «Concludi».",
      bsDlProtection: "Modalità di protezione",
      bsDlProtectionState: "Stato",
      bsDlProtectionOn: "attiva dal {time}",
      bsDlProtectionOff: "non attiva",
      bsDlScope: "Entità del download",
      bsDlScopeValue: "{files} file, {size}",
      bsDlDeferredDeletes: "Cancellazioni trattenute",
      bsDlDeferredOverwrites: "Sovrascritture trattenute",
      bsDlAddedSince: "Aggiunti dall'avvio",
      bsDlLastActivity: "Ultimo segno di vita",
      acqTitle: "Fonti di dati",
      acqSubtitle: "Fonti curate con licenza aperta: per ciascuna la licenza, la valutazione di protezione dei dati, la lingua, la modalità, l'obiettivo in byte e l'avanzamento misurato. Le fonti disattivate nominano il loro motivo invece di mancare in silenzio.",
      acqGdprNote: "Principio GDPR: i dati di addestramento sono ammessi solo da fonti con licenza aperta e valutazione documentata di protezione dei dati; i dati della casella passano una pulizia PII prima della creazione di esempi (il contatore «ripuliti PII» lo mostra).",
      acqSource: "Fonte",
      acqModality: "Modalità · lingua",
      acqLicense: "Licenza",
      acqProtection: "Protezione dei dati",
      acqProgress: "Avanzamento",
      acqDocs: "{count} file/oggetti ricevuti",
      acqTargetReached: "obiettivo raggiunto",
      acqExhausted: "fonte esaurita (il listing non fornisce più nulla)",
      acqEnabledPill: "attiva",
      acqWaitingBuffer: "in attesa: buffer pieno, il caricamento recupera",
      acqDisabledPill: "disattivata",
      acqEnable: "Attiva",
      acqDisable: "Disattiva",
      acqEnabledMsg: "Fonte attivata",
      acqDisabledMsg: "Fonte disattivata",
      acqTargetLabel: "Obiettivo (GB)",
      acqSetTarget: "Salva obiettivo",
      acqTargetSaved: "Obiettivo salvato",
      acqEmpty: "Nessuna fonte registrata finora.",
      balanceTitle: "Equilibrio linguistico tedesco/inglese",
      balanceSubtitle: "Byte scaricati per modalità e lingua — per le fonti iniziali il tedesco non deve restare dietro l'inglese.",
      balanceEmpty: "Ancora nessuna misurazione.",
      modText: "Testo",
      modAudio: "Audio",
      modImage: "Immagine",
      modVideo: "Video",
      prepTitle: "Pre-elaborazione",
      prepSubtitle: "Fasi della pipeline contate, dal documento grezzo registrato all'esempio di addestramento — ogni numero viene dal catalogo; errori ed elementi non supportati sono nominati.",
      prepRegistered: "registrati",
      prepScrubbed: "ripuliti PII",
      prepChunked: "suddivisi",
      prepEmbedded: "con embedding",
      prepExtracted: "estratti",
      prepLinked: "collegati",
      prepSamples: "esempi",
      prepByLang: "Per lingua",
      prepUnsupported: "Non supportato",
      prepAwaiting: "In attesa di una fase",
      prepFailures: "Errori",
      inboxTitle: "Casella dei dati grezzi",
      assetWhat: "Contenuto",
      assetFromSource: "dalla fonte {source}",
      assetFromUpload: "caricato manualmente",
      mediaParquet: "Dati tabellari (Parquet)",
      treeShardsHint: "Gli shard sono i pacchetti di dati Parquet del catalogo: ogni riga è un pacchetto con origine, lingua e scopo — la colonna «scopo» dice cosa contiene una cartella.",
      mediaWords: {
        text: "Testo",
        audio: "Audio",
        video: "Video",
        image: "Immagine",
        application: "File",
      },
      inboxSubtitle: "Consegnare i propri dati grezzi al lake: caricare qui o depositare direttamente nella cartella cloud raw/inbox/. La riconciliazione registra ogni file; «Elabora ora» avvia lo stesso percorso che l'autopilota compie da solo.",
      uploadButton: "Carica file",
      uploadHint: "Fino a 512 MB per file. I caricamenti finiscono nel cold store e durante l'elaborazione vengono suddivisi, trasformati in embedding e collegati al grafo della conoscenza.",
      uploadTooLarge: "Il file supera i 512 MB.",
      uploadDone: "File accettato",
      processNow: "Elabora ora",
      processStarted: "Elaborazione avviata",
      reconcileNow: "Riconcilia cartella cloud",
      reconcileDone: "Riconciliazione eseguita",
      unprocessedCount: "{count} non elaborati",
      inboxEmpty: "La casella è vuota.",
      assetName: "File",
      assetType: "Tipo",
      assetSize: "Dimensione",
      assetState: "Stato",
      assetLang: "Lingua",
      assetRegistered: "Registrato",
      assetStates: {
        raw_stored: "dati grezzi salvati",
        awaiting_stt: "in attesa del riconoscimento vocale",
        awaiting_content_fetch: "in attesa del contenuto dietro l'indirizzo",
        awaiting_image_codec: "in attesa del codec immagine",
        awaiting_audio_codec: "in attesa del codec audio",
        awaiting_video_codec: "in attesa del codec video",
        chunked: "suddiviso e nel grafo",
        processed: "elaborato",
        registered: "registrato",
        queued: "in attesa",
        processing: "in elaborazione",
        ingested: "acquisito",
        linked: "collegato",
        unsupported: "non supportato",
        failed: "fallito",
      },
      graphTitle: "Grafo della conoscenza",
      graphSubtitle: "Il corpus grezzo collegato: nodi e archi contati dal catalogo — da questi collegamenti nascono gli esempi di addestramento.",
      graphEmbedded: "Nodi con embedding",
      graphModel: "Modello di embedding",
      graphClusters: "Cluster",
      graphAssetsLinked: "Dati grezzi collegati",
      graphLastLink: "Ultimo collegamento",
      graphNodesTitle: "Nodi per tipo",
      graphEdgesTitle: "Archi per tipo",
      graphEmpty: "Il grafo è ancora vuoto — nasce con il primo file elaborato.",
      kindCol: "Tipo",
      countCol: "Numero",
      neighborsTitle: "Vicini di un nodo",
      nodeIdLabel: "ID del nodo",
      neighborsRun: "Recupera vicini",
      neighborsEmpty: "Nessun vicino trovato.",
      nodeCol: "Nodo",
      edgeKindCol: "Arco",
      weightCol: "Peso",
      gapTitle: "Matrice di copertura e lacune",
      gapSubtitle: "Inventario misurato rispetto agli obiettivi di miscelazione configurati per capacità, firma e livello — una vista SQL sul catalogo, mai cablata.",
      tier: "Livello",
      gapHave: "Attuale",
      gapTarget: "Obiettivo",
      gapWeight: "Peso",
      gapPriority: "Priorità",
      targetsTitle: "Definire gli obiettivi di miscelazione",
      targetsSubtitle: "Gli obiettivi portano autore e orario; senza obiettivi la matrice mostra onestamente lo stato vuoto.",
      addTargetRow: "Aggiungi riga",
      saveTargets: "Salva obiettivi",
      targetsSaved: "Obiettivi salvati",
      statusCol: "Stato",
      tdvTitle: "Versione dei dati sigillata",
      tdvSubtitle: "La versione dei dati è immutabile e composta da shard sigillati; una nuova sostituisce la precedente.",
      createTdv: "Crea bozza di TDV",
      tdvCreated: "Bozza di TDV creata",
      tdvId: "TDV",
      tdvName: "Nome",
      tdvMembers: "Membri",
      tdvCreatedAt: "Creata",
      tdvSealedAt: "Sigillata",
      tdvStatusDraft: "bozza",
      tdvStatusSealed: "sigillata",
      sealTdv: "Sigilla",
      tdvSealed: "TDV sigillata",
      tdvEmpty: "Ancora nessuna Train Data Version — nasce da shard sigillati.",
      compatTitle: "Verifica di compatibilità tra architettura e dati",
      compatSubtitle: "Regole R1–R12 su due documenti leggibili da macchina; il cruscotto mostra il rapporto memorizzato del motore e non calcola alcun verdetto proprio.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "non ALL-GREEN",
      compatRun: "Esegui verifica",
      compatChecked: "Verifica eseguita",
      compatSelectTdv: "Selezionare una TDV nell'elenco sopra per vederne il rapporto.",
      compatNoReport: "Per questa TDV non esiste ancora un rapporto di compatibilità memorizzato.",
      compatDraftNote: "L'interfaccia dati dell'architettura è una bozza — gli artefatti di tokenizer e codec non esistono ancora; la verifica si attiva con il primo rilascio del tokenizer e la prima TDV sigillata.",
      compatRule: "Regola",
      compatTitleCol: "Titolo",
      compatKind: "Tipo",
      compatEvidence: "Valori confrontati (evidenza)",
      kindHard: "vincolante",
      kindWarn: "avviso",
      reportsTitle: "Rapporti memorizzati",
      reportsEmpty: "Nessun rapporto di compatibilità memorizzato finora.",
      phaseLabel: "Fase di addestramento",
      phaseA: "Fase A — preparazione ed evoluzione",
      phaseB: "Fase B — addestramento in corso, architettura congelata",
      checklistTitle: "Prontezza all'addestramento (checklist fase A)",
      checklistSubtitle: "Condizioni calcolate in diretta; l'avvio resta bloccato finché ogni punto non è verde, e ogni punto non soddisfatto viene nominato.",
      checklistReady: "pronto",
      checklistUnmet: "{count} punti non soddisfatti",
      checklistUnavailable: "La checklist non è raggiungibile.",
      itemSatisfied: "soddisfatto",
      itemUnsatisfied: "non soddisfatto",
      startTraining: "Avvia fase B",
      strandTitle: 'Ramo di addestramento',
      strandSubtitle: 'Quale ramo del modello viene addestrato quando tutte le condizioni sono soddisfatte; il ramo non selezionato continua a preparare i dati ma non parte mai.',
      strandSelectedBadge: 'selezionato',
      strandExplain: 'L\'autopilota addestra {selected}. {other} continua a raccogliere e preparare, ma non parte finché non è selezionato.',
      strandSwitched: 'Selezione salvata.',
      strandSwitchFailed: 'Cambio non riuscito.',
      strandUnavailable: 'Questo backend non fornisce ancora i rami; il selettore apparirà dopo il prossimo rollout del core.',
      trainingStarted: "Fase B avviata",
      startBlocked: "Avvio bloccato — non soddisfatti: {items}",
      selectedTdvLabel: "Versione dei dati scelta",
      computedAt: "Calcolato",
      runsTitle: "Esecuzioni di addestramento",
      runsSubtitle: "Solo esecuzioni reali dal catalogo; non esiste alcun processo di addestramento simulato.",
      runId: "Esecuzione",
      archVersion: "Architettura",
      presetCol: "Preset",
      seqLenCol: "Lunghezza di sequenza",
      stepCol: "Passo",
      lossCol: "Loss",
      runStarted: "Avviata",
      runFinished: "Conclusa",
      runsEmpty: "Ancora nessuna esecuzione di addestramento.",
      abortRun: "Interrompi",
      confirmAbort: "Interrompere questa esecuzione di addestramento?",
      runAborted: "Interruzione richiesta",
      benchLink: "Benchmark",
      benchTitle: "Report di benchmark",
      benchSubtitle: "La suite congelata e versionata viene eseguita automaticamente dopo ogni addestramento; ogni report è conservato nel lake e mostrato qui.",
      benchEmpty: "Ancora nessun report di benchmark.",
      suiteVersion: "Suite",
      benchOpen: "Apri",
      benchReportFor: "Report di benchmark per l'esecuzione {run}",
      benchNoMarkdown: "Questo report non porta un documento renderizzato; i risultati grezzi sono qui sotto.",
      exportsTitle: "Export",
      exportsSubtitle: "I download esistono esclusivamente per gli export di addestramenti reali completati.",
      exportId: "Export",
      exportSize: "Dimensione",
      exportSha: "SHA-256",
      download: "Scarica",
      exportsEmpty: "Ancora nessun export — nasce solo da un addestramento reale completato.",
      hfTitle: "Pubblicazioni HuggingFace",
      hfSubtitle: "Ogni caricamento è privato; la visibilità viene verificata via API dopo il caricamento. Un risultato non privato è uno stato di errore che ferma il ciclo.",
      hfEmpty: "Ancora nessuna pubblicazione.",
      hfRepo: "Repository",
      hfState: "Stato",
      hfVisibility: "Visibilità",
      hfPrivateVerified: "privato — verificato",
      hfUnverified: "non ancora verificato",
      hfVerifiedAt: "Verificato",
      connectTitle: "Collegare Block Storage",
      connectSubtitle: "Accesso tramite la finestra di accesso del provider di archiviazione; lo storage si collega all\'account che conferma.",
      webConnectStart: "Connetti con il provider di archiviazione",
      webConnectWaiting: "In attesa della conferma nella finestra di accesso del provider di archiviazione…",
      webConnectHint: "Dopo la conferma lo storage si collega automaticamente; questa finestra si aggiorna da sola.",
      publicIdentity: "Identità app pubblica (rclone, quota condivisa)",
      publicIdentityNote: "La finestra di accesso del provider di archiviazione mostra “rclone” come app richiedente — l\'identità condivisa pubblicamente; un client ID proprio (GDRIVE_OAUTH_CLIENT_ID) la sostituisce in qualsiasi momento.",
      manualHint: "Dopo la conferma il browser mostra una pagina localhost irraggiungibile. Copiare il valore del parametro code= dalla barra degli indirizzi e incollarlo qui (va bene anche l\'indirizzo intero).",
      manualCodeLabel: "Codice di autorizzazione",
      manualSubmit: "Riscatta codice",
      deviceInstead: "Usa invece un codice dispositivo",
      licenseAcceptLink: "Confermare la licenza su Hugging Face",
      deviceFlowTitle: "Collega Block Storage (device flow)",
      deviceFlowSubtitle: "Il motore avvia il flusso di accesso del provider per dispositivi; la conferma avviene su un secondo dispositivo, interrogata a intervalli limitati.",
      deviceFlowStart: "Avvia il flusso di accesso",
      deviceFlowCode: "Codice dispositivo",
      deviceFlowOpenUrl: "Apri la pagina di conferma",
      deviceFlowWaiting: "In attesa della conferma — l'interrogazione segue l'intervallo prescritto dal provider.",
      deviceFlowAuthorized: "Collegato",
      deviceFlowExpired: "Il codice dispositivo è scaduto — riavviare il flusso di accesso.",
      readinessTitle: "Prontezza all'addestramento",
      readinessSubtitle: "Il percorso misurato verso il primo addestramento, fase per fase.",
      readinessCounter: "{green} di {total} soddisfatte",
      readinessReady: "Pronto per l'addestramento",
      unblockLabel: "Prossimo passo",
      readinessUnavailable: "La panoramica di prontezza non è ancora attiva nel backend. Non appena l'endpoint sarà disponibile, qui apparirà lo stato misurato.",
      stageStates: {
        ok: "soddisfatta",
        active: "in corso",
        waiting: "in attesa",
        blocked: "bloccata",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'non disponibile',
      equilibrium: 'Stato operativo ottimale raggiunto: tutte le richieste hanno ricevuto risposta, tutti i passaggi di consegne sono stati elaborati e le ridondanze sono state evitate.',
      standby: 'standby',
      defTitle: 'Coordinamento Operativo del Team & Metriche di Performance',
      defSubtitle: 'Misurazione della qualità operativa di comunicazione e passaggio di consegne di tutti i ruoli IA: focus su risultati verificati anziché attività improduttiva.',
      defPlayers: 'Ruoli & Sistemi Coinvolti',
      defPlayersText: 'I dieci ruoli IA specializzati con i rispettivi bot Webex e i decisori umani che definiscono incarichi e linee guida.',
      defStrategies: 'Principi di Comunicazione & Operatività',
      defStrategiesText: 'Risposta diretta ai quesiti, passaggi di consegne completi e univoci, eliminazione delle ridondanze e chiusura rigorosa dei pacchetti di lavoro aperti.',
      defPayoff: 'Contributo Operativo Netto (Utilità Netta)',
      defPayoffText: 'Pacchetti di lavoro completati, passaggi di consegne elaborati con successo e richieste evase — meno le perdite per attrito (ridondanze, consegne non elaborate, richieste inevase).',
      defEquilibrium: 'Stato Operativo Ottimale (Equilibrio di Coordinamento)',
      defEquilibriumText: 'Stato obiettivo della collaborazione: ogni richiesta riceve risposta nei tempi, ogni passaggio di consegne viene preso in carico, nessuna informazione è inviata due volte e nessun pacchetto resta bloccato.',
      playersTitle: 'Panoramica delle Performance per Ruolo (Posizioni)',
      playersSubtitle: 'Indicatori operativi di comunicazione e consegna per ruolo: contributi specialistici e passaggi di consegne (ultimi 7 giorni) oltre a riunioni e pacchetti completati (ultimi 30 giorni).',
      playersHint: 'Utilità netta = 3 × pacchetti completati + consegne elaborate − perdite per attrito (le consegne non elaborate contano doppio). Un valore negativo indica necessità di coordinamento.',
      player: 'Ruolo / Posizione',
      contributions: 'Contributi',
      meetingTurns: 'Riunioni',
      handovers: 'Consegne',
      consumedShort: 'elaborate',
      refusedShort: 'rifiutate',
      delivery: 'Recapito',
      pausedTurns: 'Turni in pausa',
      pausedTurnsHint: 'Turni conservati nella casella del collega perché i modelli non hanno potuto servirli subito. Non sono consegne.',
      closedOpen: 'chiusi / aperti',
      noise: 'Perdita per attrito',
      utility: 'Contributo netto',
      meetingsLine: '{held} riunioni, {turns} interventi, {u} interpelli senza risposta (30 giorni).',
      interactionsTitle: 'Passaggi di Consegne tra Ruoli (Matrice di Handover)',
      interactionsSubtitle: 'Passaggi di consegne diretti tra le caselle (ultimi 7 giorni): numero, tempo di recapito e consegne elaborate o rifiutate.',
      interactionsHint: 'Un passaggio di consegne è considerato concluso solo dopo l\'elaborazione da parte del destinatario; le consegne rifiutate o inevase sono segnalate come deviazioni di processo.',
      interactionsEmpty: 'Nessuna consegna nella finestra.',
      from: 'Da',
      to: 'A',
      messages: 'Messaggi',
      consumed: 'elaborate',
      refused: 'rifiutate',
      deviationsTitle: 'Deviazioni di Processo & Colli di Bottiglia Aperti',
      deviationsSubtitle: 'Carenze di coordinamento attuali: richieste senza risposta, passaggi di consegne non elaborati, contributi ridondanti o pacchetti di lavoro bloccati.',
      dev_unanswered_question: 'Richiesta senza risposta (timeout superato)',
      dev_dead_air: 'Passaggio di consegne senza riscontro',
      dev_repetition: 'Ripetizione nella riunione',
      dev_meeting_unanswered: 'Richiesta diretta senza riscontro',
      dev_work_blocked: 'Lavoro bloccato',
      dev_handover_hop_budget_reached: 'Budget di passaggi di consegna superato',
      dev_commitment_unkept: 'Impegno di sprint non mantenuto',
      devWithheld: 'trattenuto',
      devRepetition: 'ripetizione',
      devDeadAir: 'consegna non elaborata',
      devMeetingUnanswered: 'senza risposta',
      effectiveThresholdCol: 'Soglia eff.',
      excessHopsLabel: 'Passaggi di consegna in eccesso',
      timeTitle: 'Tempi di Ciclo & Confronto di Produttività (IA vs lavorazione manuale)',
      timeSubtitle: 'Durata effettiva di elaborazione IA dei compiti di sviluppo completati rispetto al carico di lavoro manuale stimato.',
      timeHint: 'Valori di riferimento analitici per la stima dell\'impegno; configurabili dalla direzione.',
      avgCycle: 'Ciclo IA medio',
      fromTasks: 'da {n} task',
      speedup: 'Accelerazione',
      speedupHint: '{h} ore umane ipotizzate per pezzo',
      humanDelivered: 'Giorni-uomo consegnati',
      humanDays: 'giorni-uomo',
      forecast: 'Previsione del lavoro aperto: {d} giorni-uomo',
      sizes: 'Dimensioni',
      sizeSmall: 'piccoli',
      sizeMedium: 'medi',
      sizeLarge: 'grandi',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'Lo sprint, gli story point e la velocity, dai dati propri dell\'azienda',
      sprintLabel: 'Sprint {n}',
      ends: 'termina',
      committedPts: 'Punti impegnati',
      deliveredPts: 'Punti consegnati',
      remainingPts: 'Punti rimanenti',
      burndownTitle: 'Burndown (punti rimanenti al giorno)',
      velocityTitle: 'Velocity degli sprint chiusi',
      predictability: 'prevedibilità',
      forecastLine: 'Velocity mobile {v} punti per sprint · backlog {b} punti ≈ {s} sprint',
      noSprint: 'Nessuno sprint in corso; la prossima pianificazione ne apre uno.',
      noItems: 'Niente è ancora impegnato; lo sprint prende ciò che le persone portano.',
      colItem: 'Elemento',
      colOwner: 'Responsabile',
      colPoints: 'Punti',
      colState: 'Stato',
      itemDone: 'consegnato',
      itemOpen: 'aperto',
      unestimated: 'non stimato',
      addedBy: 'aggiunto da {who}',
      setGoal: 'Obiettivo dello sprint',
      sprintDaysLabel: 'Durata dello sprint (giorni)',
      save: 'Salva',
      endSprint: 'Chiudi lo sprint adesso',
      confirmEndSprint: 'Chiudere lo sprint adesso? Review, retrospettiva e la prossima pianificazione si tengono subito.',
      planNow: 'Tieni la prima pianificazione adesso',
      confirmPlanNow: 'Tenere la pianificazione dello sprint adesso? Apre il primo sprint in pAIoneer-scrum.',
      sprintPointsCol: 'Punti sprint',
      ceremonySpaceLabel: 'Spazio cerimonie',
      scrumOfScrums: 'Tieni Scrum of Scrums',
      confirmScrumOfScrums: 'Tenere lo Scrum of Scrums tra tutte le Business Unit adesso?',
      lastScrumOfScrumsTitle: 'Ultimo Scrum of Scrums',
      escalatedImpedimentsTitle: 'Impedimenti escalati',
      unitBreakdownTitle: 'Ripartizione dello sprint per Business Unit',
      colUnit: 'Business Unit',
      colWip: 'Lavoro aperto',
      colImpediments: 'Impedimenti',
    },
    nav: {
      groups: {
        gametheory: 'Coordinamento Team & Scrum',
        demos: 'Anteprime Live',
        sovereign: 'LLM sovrano',
        today: 'Panoramica Giornaliera & Sala Controllo',
        organisation: 'Organizzazione',
        work: 'Lavoro',
        communication: 'Comunicazione',
        memory: 'Memoria',
        platform: 'Piattaforma',
        products: 'Prodotti',
        identity: 'Identità',
      },
      pages: {
        gametheory: 'Coordinamento Team & Scrum',
        demos: 'Anteprime Live',
        llm: 'Architettura LLM — articolo',
        training: 'Data Lake & Addestramento Modelli IA',
        today: 'Panoramica Giornaliera & Sala Controllo',
        work: 'Pacchetti di lavoro e progetti',
        coding: 'Compiti di programmazione',
        gitlab: 'GitLab & Build di immagini',
        agents: 'Agenti e progetti di agenti',
        research: 'Ricerche',
        webex: 'Spazi Webex',
        mailboxes: 'Caselle',
        conversations: 'Chiamate e conversazioni',
        meetings: 'Riunioni',
        engines: 'Motori IA & GPU',
        usage: 'Consumo e budget',
        workloads: 'Servizi container',
        orchestrator: 'Orchestratore MCP Veridion',
      },
      sections: {
        demos: {
          previews: 'Anteprime live',
        },
        llm: {
          paper: 'Articolo',
          monitoring: 'Monitoraggio',
        },
        training: {
          autopilot: "Autopilota",
          storage: "Archiviazione cloud & albero cartelle",
          acquisition: "Acquisizione & pre-elaborazione",
          data: "Dati & grafo della conoscenza",
          training: "Addestramento & pubblicazione",
        },
        platform: {
          nodes: 'Nodi del cluster',
          events: 'Eventi',
        },
        smtm: {
          runtime: 'Controllo runtime',
          prediction: 'Controllo previsioni',
          status: 'Stato dei dati',
          reporting: 'Segnali',
          training: 'Modelli',
          console: 'Console di addestramento',
        },
        agentic: {
          overview: 'Panoramica',
          tools: 'Strumenti',
          mcp: 'Server MCP',
          activity: 'Attività',
        },
        'company-memory': {
          content: 'Contenuto',
          search: 'Ricerca e quadri di situazione',
          facts: 'Fatti',
          entity: 'Entità',
          remember: 'Registra',
          audit: 'Registro di audit',
          console: 'Console di query',
          stores: 'Archivi',
          graph: 'Grafo della conoscenza',
          day: 'Giornata',
            bubbles: 'Domini di conoscenza aziendali & Ricerca'
        },
        organisation: {
          chart: 'Organigramma',
          colleagues: 'Colleghi IA e caselle',
          voices: 'Voci',
          people: 'Persone e spazi',
          approvals: 'Approvazioni e pianificazioni',
          edit: 'Modifica organizzazione',
        },
        work: {
          items: 'Pacchetti di lavoro',
          projects: 'Progetti in sviluppo',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Build di immagini',
        },
        agents: {
          agents: 'Agenti',
          designs: 'Progetti di agenti',
          definitions: 'Definizioni',
        },
        usage: {
          identities: 'Per identità',
          budgets: 'Budget di token',
          company: 'Istanza aziendale',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Runtime',
          mcp: 'Server MCP',
          tools: 'Strumenti',
          activity: 'Attività',
        },
      },
      attentionTitle: 'Interventi necessari',
      attentionSubtitle: 'Stati da tutte le aree che richiedono un intervento. Un clic apre la sezione.',
      attentionNone: 'Nessun intervento necessario.',
      stateTitle: 'Stato operativo',
      none: 'nessuno',
      readyOf: '{ready} di {total} pronti',
      connectedOf: '{connected} di {total} connessi',
      registeredOf: '{registered} di {total} registrati',
      showMore: 'Mostra altro',
      shownOf: '{shown} di {total}',
      expand: 'Espandi',
      collapse: 'Comprimi',
      service: 'Servizio',
      serviceLinks: 'Link',
      controlsTitle: 'Comandi di Veridion Core',
      confirmRemove: 'Rimuovere {what}?',
      companyIdentitiesTitle: 'Identità gateway dell\'istanza aziendale',
      companyIdentitiesSubtitle: 'I token dell\'orchestratore e di Veridion Core nella finestra corrente del gateway, ogni identità con il suo budget.',
      conversationsTitle: 'Conversazioni dal dashboard',
      conversationsSubtitle: 'Per collega IA le conversazioni scritte dal dashboard; scrivere e chiamare aprono una finestra di dialogo sopra la pagina.',
      conversationCount: 'Messaggi',
      conversationLastWritten: 'Ultimo messaggio',
      conversationLastAnswered: 'Ultima risposta',
      exchangesTitle: 'Messaggi e risposte',
      exchangesSubtitle: 'Ogni messaggio dal dashboard con la risposta del collega IA, dal più recente.',
      conversationMessage: 'Messaggio',
      conversationAnswer: 'Risposta',
      today: {
        wordTitle: 'Direttiva direzionale attiva',
        wordNone: 'Attualmente non è registrata alcuna direttiva direzionale aperta.',
        sinceTitle: 'Eventi dall\'ultima consultazione',
        sinceState: 'da {time}',
        workTitle: 'Compiti attivi & Responsabilità',
        workNone: 'Nessun pacchetto di lavoro è in corso.',
        nextMeeting: 'Prossima riunione',
        lastMeeting: 'Ultima riunione',
      },
      work: {
        title: 'Pacchetti di lavoro',
        subtitle: 'Ogni pacchetto di lavoro aperto della memoria aziendale con responsabile, stato, priorità, scadenza e i risultati dei suoi scenari; il titolo lo apre nel grafo.',
        item: 'Pacchetto di lavoro',
        kind: 'Tipo',
        owner: 'Responsabile',
        status: 'Stato',
        priority: 'Priorità',
        due: 'Scadenza',
        scenarios: 'Scenari',
        updated: 'Aggiornato',
        none: 'Nessun pacchetto di lavoro aperto.',
        all: 'Tutti i responsabili',
      },
      meetings: {
        subtitle: 'Le riunioni dei colleghi IA come le registra Veridion Core: fascia oraria, riepilogo e gli impegni diventati lavoro.',
        slot: 'Fascia oraria',
        kind: 'Tipo',
        started: 'Inizio',
        ended: 'Fine',
        summary: 'Riepilogo',
        commitments: 'Impegni',
        hold: 'Tieni una riunione ora',
        held: 'La riunione è stata convocata.',
        notHeld: 'Una riunione è in corso o si è tenuta nell\'ultima mezz\'ora.',
        holdFailed: 'Non è stato possibile convocare la riunione',
        none: 'Nessuna riunione registrata finora.',
      },
      research: {
        title: 'Ricerche',
        subtitle: 'Le ricerche dei colleghi IA dalla cronologia dell\'azienda, dalle più recenti.',
      },
      attention: {
        toneError: 'Guasto',
        toneWarning: 'Avviso',
        state: {
          platform: '{ready} di {workloads} workload pronti, {nodes} di {total} nodi pronti, {restarts} riavvii.',
          gateway: '{state}; {models} modelli instradati, {backends} di {total} backend di serving pronti.',
          engine: '{engine}: {running} in corso, {waiting} in attesa',
          usage: '{tokens} token su {identities} identità nella finestra {window}.',
          smtm: 'Gate di previsione {gate}, ricostruzione {rebuild}; {online} di {models} modelli online, {failed} falliti.',
          smtmSignals: '{open} segnali aperti, {resolved} risolti, {failed} consegne fallite.',
          smtmVeridion: '{connected} di {servers} server MCP connessi.',
          company: 'Orchestratore {status}; {ready} di {workloads} workload pronti; Veridion Core {core}; {agents} agenti in esecuzione, {waiting} in attesa.',
          companyWebex: '{registered} di {bots} webhook dei bot registrati.',
          approvals: '{approvals} approvazioni aperte; {tasks} attività di coding attendono una persona o una revisione.',
          sessions: '{users} utenti connessi, {sessions} sessioni, {mfa} verificate, {total} account.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Lo stato della piattaforma non è leggibile.',
        nodeNotReady: 'Il nodo {name} non è pronto.',
        nodePressure: 'Il nodo {name} segnala saturazione: {pressure}.',
        workloadDown: '{name} ({namespace}): {ready} di {desired} pronti.',
        gatewayNotProgrammed: 'Il gateway IA non è programmato.',
        smtmGateClosed: 'Il cancello delle previsioni è chiuso.',
        smtmRebuild: 'È segnata una ricostruzione.',
        smtmHint: 'Stato dei dati: {hint}.',
        smtmDeliveryFailed: '{count} consegne di segnali non riuscite.',
        smtmModelsFailed: '{count} modelli segnalano un errore.',
        mcpUnreachable: 'Il server MCP {server} di {instance} non è raggiungibile.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} non risponde.',
        parts: {
          orchestrator: 'l\'orchestratore',
          webex: 'il bridge Webex',
          knowledge: 'la base di conoscenza',
          core: 'Veridion Core',
          mcp: 'i server MCP',
          usage: 'il registro dei consumi',
          gateway: 'il consumo del gateway',
        },
        emergencyStop: 'L\'arresto di emergenza di Veridion Core è attivo.',
        coreMisconfigured: 'A Veridion Core mancano impostazioni: {missing}.',
        agentsWaiting: '{count} agenti attendono una risposta.',
        hostedNotRunning: '{agent} non è in esecuzione.',
        webhookMissing: 'Il webhook di {bot} non è registrato.',
        readerNotAuthorised: 'La lettura degli spazi aziendali non è autorizzata.',
        approvalOpen: 'Approvazione aperta ({position}): {question}',
        taskWaiting: 'Attività di codice in attesa di una persona: {title}',
        taskReview: 'Merge request pronta per la revisione: {title}',
      },
    },
    ops: {
      showDetails: 'Dettagli',
      hideDetails: 'Chiudi',
      mcpVersion: 'Versione',
      mcpUrl: 'Indirizzo',
      mcpProtocol: 'Trasporto e protocollo',
      mcpLastRefresh: 'Ultima interrogazione',
      mcpError: 'Errore',
      noTools: 'Nessuno strumento segnalato.',
      toolServer: 'Origine',
      toolAccess: 'Accesso',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'lettura',
      accessWrites: 'scrittura',
      accessDestructive: 'modifica dati',
      accessUndeclared: 'non dichiarato',
      usageTitle: 'Consumo',
      smtmUsageSubtitle: 'Chiamate ai modelli, token e costi dichiarati dal fornitore negli ultimi 30 giorni.',
      usageByPerson: 'Per persona',
      usageByModel: 'Per modello',
      usageByDay: 'Per giorno',
      model: 'Modello',
      day: 'Giorno',
      promptTokens: 'Token di input',
      completionTokens: 'Token di output',
      noUsage: 'Nessun consumo registrato.',
      runtimeTitle: 'Esecuzione',
      runtimeSubtitle: 'Come l\'orchestratore di questa istanza si rivolge ai modelli e collega gli strumenti.',
      executionMode: 'Esecuzione',
      providerProtocol: 'Protocollo verso il modello',
      contextWindow: 'Finestra di contesto',
      requestTimeout: 'Timeout per richiesta',
      diagnostics: 'Diagnostica',
      diagnosticsOn: 'attiva',
      diagnosticsOff: 'disattiva (modalità prestazioni)',
      externalServers: 'Server MCP collegati',
      mcpEndpoint: 'Endpoint MCP',
      workloadsTitle: 'Workload',
      workloadsSubtitle: 'I workload nel namespace paioneer-veridion come li segnala Kubernetes.',
      botsTitle: 'Bot',
      botsSubtitle: 'I bot dell\'organizzazione, ciascuno con il suo webhook, e i servizi del bridge.',
      botAddress: 'Indirizzo',
      cardWebhook: 'Webhook delle schede',
      webhookState: 'Stato',
      noBots: 'Il bridge non segnala bot.',
      bridgeServices: {
        knowledgeBase: 'Base di conoscenza',
        webResearch: 'Ricerca in Internet',
        osint: 'OSINT',
        anonymizer: 'Anonimizzazione',
      },
      connected: 'collegato',
      notConnected: 'non collegato',
      activeRooms: 'Stanze attive',
      allowedRooms: 'Stanze consentite',
      surface: 'Superficie',
      missingSettings: 'Impostazioni mancanti',
      none: 'nessuna',
      instanceToolsTitle: 'Strumenti dell\'orchestratore',
      instanceToolsSubtitle: 'Gli strumenti che l\'orchestratore dell\'istanza aziendale ha registrato.',
      openMailbox: 'Casella',
      positionMailboxHint: 'I colleghi IA elaborano i passaggi di altri colleghi IA; un incarico a un collega IA si dà nel suo spazio Webex.',
      mailboxesTitle: 'Caselle',
      mailboxesSubtitle: 'Per ogni agente, cosa attende nella sua casella, è stato consegnato ed è stato letto. Un clic su una riga filtra i messaggi.',
      readAt: 'Letto alle',
      refresh: 'Aggiorna',
      mailbox: 'Casella',
      mailboxKind: 'Tipo',
      mailboxKinds: {
        position: 'Collega IA',
        hosted: 'Agente ospitato',
        graph: 'Agente',
      },
      lastMessage: 'Ultimo messaggio',
      noMailboxes: 'Nessuna casella leggibile.',
      messagesTitle: 'Messaggi',
      messagesSubtitle: 'Messaggi, comandi e passaggi, i più recenti prima. Un clic mostra il testo completo.',
      allMailboxes: 'Tutte le caselle',
      allStates: 'Tutti gli stati',
      time: 'Ora',
      from: 'Da',
      to: 'A',
      messageKind: 'Tipo',
      content: 'Contenuto',
      reply: 'Risposta',
      noMessages: 'Nessun messaggio.',
      messageKinds: {
        message: 'Messaggio',
        handover: 'Passaggio',
        command: 'Comando',
        resume: 'Ripresa',
        subagent_result: 'Risultato di un sotto-agente',
        review: 'Revisione',
      },
      buildsTitle: 'Build',
      buildsSubtitle: 'Le immagini che Veridion Core ha costruito per gli agenti, le più recenti prima.',
      image: 'Immagine',
      started: 'Avviato',
      finished: 'Terminato',
      noBuilds: 'Nessuna build.',
      coreToolsTitle: 'Strumenti degli agenti',
      coreToolsSubtitle: 'Gli strumenti dell\'orchestratore che Veridion Core offre ai suoi agenti.',
      description: 'Descrizione',
      coreDailyTitle: 'Consumo per giorno e modello',
      coreDailySubtitle: 'Chiamate ai modelli di Veridion Core negli ultimi 30 giorni, per agente e modello.',
      coreActivityTitle: 'Attività di Veridion Core',
      coreActivitySubtitle: 'Eventi di agenti, colleghi IA e passaggi in Veridion Core, i più recenti prima.',
      event: 'Evento',
      tool: 'Strumento',
      detail: 'Dettaglio',
    },
    tabCompanyMemory: 'Memoria aziendale',
    llmPaper: {
      subtitle: 'La descrizione scientifica generata dell’architettura sovrana del modello — resa dal documento in stile articolo che Veridion Core mantiene per la specifica attiva.',
      summaryTitle: 'Cosa mostra questa pagina',
      summaryBody: 'Veridion Core mantiene per l’architettura attiva un documento scientifico generato: titolo, abstract, sezioni numerate, diagramma dell’architettura, tabelle e riferimenti arrivano dal backend senza modifiche; i valori di progetto sono contrassegnati come tali e la pagina non inventa nulla.',
      refresh: 'Aggiorna',
      exportPdf: 'Esporta come PDF',
      strandTraining: 'in addestramento',
      strandSelected: 'selezionato',
      lcTitle: "Implementazione e ciclo di vita",
      lcSelectedTrains: "si addestra per primo",
      lcCollectsOnly: "raccoglie e prepara — non parte",
      lcSpec: "Specifica",
      lcFrozen: "congelata",
      lcArtifacts: "Artefatti (tokenizzatore/codec)",
      lcReleased: "rilasciati",
      lcNotReleased: "non ancora costruiti",
      lcCodecOpen: "codec in sospeso",
      lcData: "Soglie dati",
      lcThresholdsMet: "raggiunte",
      lcAreasReached: "piano dei dati: {met} aree su {total} raggiunte",
      lcNoLake: "data lake non disponibile",
      lcStage_trainer_image: "Immagine del trainer",
      lcStage_sealed_tdv: "TDV sigillata",
      lcStage_compat_all_green: "Compatibilità ALL-GREEN",
      lcStage_vram_budget: "Budget VRAM",
      lcTraining: "Addestramento",
      lcAuto: "parte automaticamente al raggiungimento delle soglie",
      lcBench: "Benchmark",
      lcBenchRows: "misurazioni",
      lcNoneYet: "ancora nessuna",
      lcRelease: "Export · Hugging Face (privato) · registro",
      lcReleaseRows: "artefatti",
      lcReleaseNote: "dopo l'addestramento: upload verificato privato + voce di registro",
      lcPipeline: "Pipeline di addestramento",
      lcDone: "fatto",
      lcActive: "attivo",
      lcWaiting: "in attesa",
      lcBlocked: "bloccato",
      lcCapability: "Capacità",
      lcSamples: "Campioni",
      lcByLanguage: "per lingua",
      lcForeign: 'altro filone',
      lcCorpus: 'Token del corpus',
      lcCorpusNone: 'non ancora tokenizzato',
      loading: 'Caricamento …',
      unavailable: 'Il documento non è raggiungibile.',
      noPaper: 'Questa versione di Veridion Core non fornisce ancora un documento in stile articolo. La pagina quindi non mostra nulla di inventato.',
      abstract: 'Abstract',
      references: 'Riferimenti bibliografici',
      appendix: 'Appendice',
      figure: 'Figura',
      lastUpdated: 'Ultimo aggiornamento',
      empty: 'Nessuna voce.',
    },
    llmMonitor: {
      summary: "Monitoraggio operativo del modello: stato, dati, GPU, kernel e throughput, valutazioni ed eventi — misurati da Veridion Core e dal data lake, niente di inventato.",
      archTitle: 'Stato dell’architettura',
      archSubtitle: "L'architettura attiva con lo stato dell'interfaccia dati e lo stato di congelamento.",
      version: 'Versione',
      codename: 'Nome in codice',
      statusLabel: 'Stato',
      interfaceStatus: 'Interfaccia dati',
      specSha: 'Hash della specifica (SHA-256, abbreviato)',
      promotedAt: 'Promossa',
      frozenLabel: 'Congelata',
      frozenYes: 'Sì',
      frozenNo: 'No',
      stateWord_active: "attiva",
      stateWord_draft: "bozza",
      stateWord_released: "rilasciata",
      stateWord_candidate: "candidata",
      stateWord_retired: "ritirata",
      gpuModel: "Scheda grafica",
      gpuTotal: "Memoria grafica totale",
      gpuWindow: "Finestra di addestramento (misurata)",
      gpuMeasuredAt: "Misurato il",
      gpuSource: "Fonte della misura",
      gpuServing: "Servizio",
      gpuInferenceTarget: "Obiettivo di inferenza su una scheda",
      vramTitle: 'GPU e budget VRAM',
      vramSubtitle: 'Il budget VRAM misurato della scheda grafica così come lo tiene Veridion Core.',
      vramNone: 'Nessun budget VRAM nel record.',
      gateTitle: 'Gate di promozione',
      gateSubtitle: 'La regola con cui un’architettura candidata sostituisce quella attiva, con le metriche richieste e i loro pesi.',
      metric: 'Metrica',
      weight: 'Peso',
      gateNone: 'Nessuna metrica richiesta registrata.',
      candidatesTitle: 'Candidate',
      candidatesNone: 'Nessuna architettura candidata.',
      evidenceTitle: 'Valutazioni',
      evidenceNone: 'Ancora nessuna valutazione misurata.',
      benchmark: 'Benchmark',
      suite: 'Suite',
      score: 'Punteggio',
      evaluator: 'Valutatore',
      date: 'Data',
      changelogTitle: 'Cronologia delle modifiche',
      changelogNone: 'Ancora nessuna versione dell’architettura nella cronologia.',
      summaryLabel: 'Riepilogo',
      createdAt: 'Creata',
      supersededAt: 'Sostituita',
      eventsTitle: 'Eventi',
      eventsNone: 'Nessun evento registrato.',
      implTitle: 'Stato di implementazione del ramo',
      implSubtitle: "Fatti misurati: artefatti dell'interfaccia dati, selezione, corpus di token e indice vettoriale; il piano dei dati per area è nella situazione.",
      implSelected: 'Ramo di addestramento',
      implSelectedYes: 'selezionato — si addestra per primo',
      implSelectedNo: 'prepara soltanto (non parte mai)',
      implTokenizer: 'Artefatto del tokenizer',
      implCodec: 'Artefatto del codec',
      implNotReleased: 'non ancora rilasciato',
      implCapability: 'Capacità',
      implSamples: 'Esempi (misurato/obiettivo)',
      implNoDatalake: 'L\'avanzamento degli esempi è momentaneamente illeggibile (interfaccia del data lake irraggiungibile).',
      implSwitchHint: 'La selezione del ramo di addestramento si cambia nella pagina di addestramento.',
      implSituationLink: "Dove sono i dati e cosa manca all'addestramento: la situazione nella pagina di addestramento",
      kernelTitle: 'Accelerazione dei kernel e throughput',
      kernelSubtitle: 'Ciò che la sonda dei kernel ha misurato sulla scheda: ogni kernel rispetto al suo riferimento, il backend di attention, il throughput della specifica scelta — e il piano temporale calcolato da token misurati e throughput misurato.',
      kernelNone: 'Nessuna sonda dei kernel è ancora stata eseguita su questa scheda; nulla viene presunto.',
      kernelName: 'Kernel',
      kernelVerified: 'Provato',
      kernelYes: 'sì',
      kernelNo: 'no',
      kernelSpeedup: 'Accelerazione',
      kernelMaxErr: 'Errore max.',
      kernelError: 'Esito',
      kernelAttention: 'Backend di attention',
      kernelDocMask: 'Mascheramento dei confini dei documenti',
      kernelThroughput: 'Throughput misurato (token/s)',
      kernelMicroBatch: 'Micro-batch',
      kernelMeasuredAt: 'Misurato il',
      kernelImage: 'Immagine del trainer (digest)',
      kernelRunPath: 'Percorso dei kernel dell\'ultima esecuzione',
      kernelRunNone: 'Nessuna esecuzione di addestramento con dati sui kernel finora.',
      kernelPlanTitle: 'Piano temporale (aritmetica su misurazioni)',
      kernelPlanTokens: 'Massa di token',
      kernelPlanTokensSource: 'Origine della massa di token',
      kernelPlanDays: 'Giorni previsti per un passaggio',
      kernelPlanNone: 'Non ancora misurato — senza throughput misurato o massa di token misurata non si inventa alcun piano temporale.',
      kernelSourceTdv: 'versione dei dati di addestramento sigillata',
      kernelSourceCorpus: 'corpus finora (non sigillato)',
      kernelSourcePlan: "budget del paper",
      implForeign: 'appartiene a un altro filone',
      implIndex: 'Indice vettoriale (collegamento del grafo)',
      implIndexNone: 'nessun indice riportato',
      implIndexDown: 'configurato, non risponde',
      implIndexPoints: 'punti',
      implIndexBackfillDone: 'riempimento completato',
      implIndexBackfillOpen: 'riempimento in corso',
      implIndexLink: 'Indice e deduplicazione nel monitor del lago',
      implCorpus: 'Corpus di token (testo grezzo)',
    },
    software: {
      arch: {
        execTitle: "Architettura di modello sovrana",
        execSubtitle: "L'unica specifica di architettura attiva da Veridion Core: ogni cifra è supportata da un artefatto di misura referenziato oppure contrassegnata dal backend come obiettivo di progetto (non misurato).",
        openDatalake: "Apri Data Lake & addestramento del modello IA",
        unavailableArch: "I dati dell'architettura non sono raggiungibili.",
        frozen: "Congelata — un addestramento è attivo",
        notFrozen: "Autorizzata (fase A)",
        version: "Versione",
        codename: "Nome in codice",
        statusLabel: "Stato",
        createdAt: "Creata",
        promotedAt: "Promossa",
        specSha: "Hash della specifica (SHA-256)",
        contextWindow: "Finestra di contesto (progetto, token)",
        dataInterface: "Interfaccia dati",
        diStatus: {
          draft: "bozza",
          complete: "completa",
          missing: "mancante",
        },
        paramsTitle: "Bilancio dei parametri",
        trainingVramTitle: "VRAM di addestramento (dichiarata, GB)",
        inferenceTitle: "VRAM di inferenza (dichiarata, GB)",
        declaredTotal: "Totale dichiarato",
        budgetTitle: "Budget VRAM della GPU (misurato)",
        budgetGpu: "GPU",
        budgetTotal: "VRAM totale (MiB)",
        budgetFreed: "Budget di addestramento libero (GB)",
        budgetInferenceTarget: "Obiettivo di inferenza su singola GPU (GB)",
        diagramTitle: "Diagramma di architettura generato",
        diagramSubtitle: "Generato in modo deterministico dalla specifica memorizzata; accanto ai dati non esiste alcun diagramma scritto a mano.",
        noDiagram: "La risposta non contiene alcun diagramma.",
        stagesTitle: "Struttura a stadi dell'architettura",
        stagesSubtitle: "Direttamente dalla specifica memorizzata; le cifre dei parametri sono valori di progetto.",
        stageCol: "Stadio",
        layersCol: "Strati",
        mechanismCol: "Meccanismo",
        paramsCol: "Parametri fisici (mld) & fonti primarie",
        paramsCross: "trasversale — conteggiato negli stadi",
        researchTitle: "Archivio di ricerca IA quantistica & frontier",
        researchSubtitle: "Righe in diretta dall'archivio di ricerca di Veridion Core; le nuove pubblicazioni arrivano tramite lo strumento del collega quantistico, ognuna con origine visibile.",
        researchEmpty: "Ancora nessuna pubblicazione nell'archivio.",
        evidenceTitle: "Evidenze di valutazione",
        evidenceSubtitle: "Qui compaiono solo valutazioni misurate e referenziate; senza evidenza non c'è punteggio.",
        evalMetric: "Metrica",
        evalBenchmark: "Benchmark",
        evalSuite: "Suite",
        evalScore: "Valore",
        evalEvaluator: "Valutatore",
        evalDate: "Misurata il",
        evalArtifact: "Artefatto di evidenza",
        gateTitle: "Regole di promozione (gate delle evidenze)",
        gateMetrics: "Metriche obbligatorie",
        gateEpsilon: "Tolleranza (epsilon)",
        gateConfigVersion: "Configurazione del gate (versione)",
        candidatesTitle: "Coda dei candidati",
        candidatesSubtitle: "Candidati di architettura presentati con lo stato delle loro evidenze; la presentazione avviene tramite il runtime di ricerca, mai dal cruscotto.",
        candidateSubmittedBy: "Presentato da",
        candidateEvidence: "Evidenze (presenti / richieste)",
        candidatesEmpty: "Nessun candidato presentato.",
        changelogTitle: "Registro delle modifiche di progetto",
        changelogSubtitle: "Iterazioni di progetto superate — volutamente senza cifre: per loro non è mai stato misurato nulla.",
        changelogSummary: "Sintesi",
        changelogEmpty: "Nessun progetto superato.",
        supersededAt: "Superata il",
        eventsTitle: "Eventi del gate",
        eventsSubtitle: "Presentazioni, promozioni, respingimenti e passaggi di congelamento così come il gate li ha registrati.",
        eventsEmpty: "Ancora nessun evento.",
      },
      title: 'Sviluppo software',
      subtitle: 'I compiti dell\'agente di programmazione, il GitLab dell\'azienda con la sincronizzazione da Azure DevOps, le merge request in attesa di revisione e i limiti del nodo GitLab.',
      openGitlab: 'Apri GitLab',
      openSonar: 'Apri SonarQube',
      loading: 'Caricamento …',
      failed: 'Non è riuscito',
      done: 'Fatto',
      unavailable: 'Non raggiungibile',
      capacityTitle: 'Nodo GitLab',
      capacitySubtitle: 'Il guardiano fissa ogni minuto i limiti del nodo in base al carico del server; la produzione mantiene la sua riserva.',
      stateLabel: 'Stato',
      memory: 'Memoria',
      cpu: 'CPU',
      disk: 'Disco',
      hostFree: 'Libero sul server',
      reserve: 'Riserva per la produzione',
      codingSlots: 'Compiti contemporanei',
      pipelineQuota: 'Job della pipeline',
      recentActions: 'Ultimi interventi del guardiano',
      syncTitle: 'Sincronizzazione da Azure DevOps',
      syncSubtitle: 'Il master di GitLab segue il master di Azure; i commit che aveva solo GitLab restano sotto un tag replaced/<ora>.',
      syncNow: 'Sincronizza ora',
      syncStarted: 'Sincronizzazione avviata',
      azureCommit: 'Master Azure',
      gitlabCommit: 'Master GitLab',
      lastChange: 'Ultima modifica',
      lastRun: 'Ultima esecuzione',
      replaced: 'Conservato sotto tag',
      noneReplaced: 'niente',
      jobs: 'Ultime esecuzioni',
      error: 'Errore',
      readyTitle: 'Merge request pronte per la revisione',
      readySubtitle: 'Solo merge request con pipeline verde; il merge si fa in GitLab.',
      noReady: 'Nessuna merge request attende una revisione.',
      tasksTitle: 'Compiti di programmazione',
      tasksSubtitle: 'Ogni lavoro di programmazione dell\'agente con stato, merge request e token.',
      showFinished: 'Mostra i compiti conclusi',
      task: 'Compito',
      requester: 'Richiedente',
      statusLabel: 'Stato',
      mergeRequest: 'Merge request',
      pipeline: 'Pipeline',
      tokens: 'Token',
      updated: 'Aggiornato',
      noTasks: 'Ancora nessun compito di programmazione.',
      phase: 'Passo',
      repository: 'Repository',
      branch: 'Branch',
      openQuestion: 'Domanda aperta',
      result: 'Risultato',
      sendMessage: 'Scrivere al compito',
      answerQuestion: 'Rispondere alla domanda',
      urgent: 'Urgente: guidare subito il passo in corso',
      send: 'Invia',
      messageSent: 'Consegnato al compito',
      confirmCancel: 'Annullare questo compito? Una merge request aperta viene chiusa.',
      course: 'Andamento della sessione',
      messages: 'Messaggi',
      events: 'Eventi',
      none: 'nessuno',
      close: 'Chiudi',
      newTitle: 'Nuovo compito',
      newSubtitle: 'Assegna da qui un compito all\'agente di programmazione; seguilo qui e sulla sua scheda Webex.',
      brief: 'Che cosa deve fare l\'agente?',
      issue: 'Issue YouTrack (facoltativo)',
      create: 'Crea compito',
      created: 'Compito creato',
      usersTitle: 'Amministratori in GitLab',
      usersSubtitle: 'Ogni amministratore ha un utente GitLab con diritti di amministrazione; l\'housekeeping li allinea a Keycloak.',
      email: 'E-mail',
      gitlabUser: 'Utente GitLab',
      lastHousekeeping: 'Ultimo housekeeping',
      sonarDeleted: 'Progetti SonarQube dei branch eliminati rimossi',
      previewsTitle: 'Progetti in sviluppo',
      previewsSubtitle: 'Ogni progetto in sviluppo gira esattamente una volta dal primo merge: Veridion Core avvia l’ultimo stato verde del ramo principale (migration o master) in container dietro l’accesso amministratore, lo rinnova a ogni pipeline verde, e qui i container si avviano, si fermano e si riavviano. Un progetto la cui pipeline non costruisce nulla che giri compare qui con il motivo.',
      previewsSummaryTitle: 'Cosa mostra questa vista',
      previewsSummaryBody: 'Ogni progetto in sviluppo gira in un proprio container di anteprima dietro l’accesso amministratore. L’elenco in alto mostra lo stato eseguibile più recente di ogni progetto, la tabella sotto i container in esecuzione con stato, indirizzo e comandi: aprire, avviare, fermare, riavviare.',
      previewProject: 'Progetto',
      previewState: 'Stato in esecuzione',
      previewSince: 'Da',
      previewAddress: 'Indirizzo',
      previewMergedAt: 'Unito',
      noPreviews: 'Nessun progetto è in esecuzione.',
      reasonsLabel: 'Cause bloccanti & Diagnostica',
      noProjects: 'Nessun progetto in sviluppo.',
      qualityCoverage: 'Copertura',
      qualityBugs: 'Bug',
      qualitySmells: 'Code smell',
      qualityDuplication: 'Duplicazione',
      qualityHotspots: 'Hotspot aperti',
      qualityUnavailable: 'Nessuna misura SonarQube',
      openPreview: 'Apri',
      startPreview: 'Avvia container',
      stopPreview: 'Ferma container',
      previewStarted: 'Container avviati',
      previewStopped: 'Container fermati',
      restartPreview: 'Riavvia container',
      previewRestarted: 'Container riavviati',
      previewControl: 'Container',
      resultTitle: 'Risultato in GitLab',
      resultJobs: 'Job e artefatti',
      resultSonar: 'SonarQube',
      resultDelivered: 'Consegnato',
      previewStatus: {
        starting: 'in avvio',
        running: 'in esecuzione',
        stopped: 'fermata',
        failed: 'fallita',
      },
      capacityStates: {
        ok: 'nei limiti',
        tight: 'stretto: la produzione ha bisogno di spazio',
        full: 'pieno: nessun nuovo lavoro',
        node_down: 'il nodo non è attivo',
      },
      status: {
        queued: 'attende un posto libero',
        working: 'in corso',
        waiting: 'attende una risposta',
        review: 'in revisione',
        merged: 'unita in GitLab',
        done: 'concluso',
        needs_person: 'serve una persona',
        rejected: 'chiusa senza merge',
        paused: 'in pausa',
        cancelled: 'annullato',
        failed: 'non riuscito',
      },
      commands: {
        pause: 'Metti in pausa',
        resume: 'Riprendi',
        cancel: 'Annulla',
      },
      repositoryChoice: {
        auto: 'Decide l\'agente',
        company: '{project} (merge da parte di una persona)',
        own: 'Un progetto proprio in {group}',
      },
      userState: {
        ok: 'allineato',
        created: 'creato',
        unblocked: 'sbloccato',
        'made administrator': 'reso amministratore',
        blocked: 'bloccato',
      },
    },
    org: {
      write: 'Scrivi',
      call: "Chiama",
      callTitle: "Chiamata con {bot}",
      writeTitle: 'Messaggio a {bot}',
      callConfirmEnd: 'Terminare la chiamata?',
      callSubtitle: 'Il microfono resta attivo per tutta la chiamata. Il bot saluta con la sua voce, risponde brevemente, chiede sui punti aperti e può essere interrotto. Ogni frase compare anche in Webex, nella stanza diretta con il bot.',
      callRinging: "Squilla …",
      callConnected: "Connesso",
      callEnded: "Terminata",
      callEndedHangup: "Ha riagganciato",
      callEndedClosed: "La connessione è stata chiusa",
      callEndedSilence: "90 secondi di silenzio",
      callEndedLimit: "È stato raggiunto il limite di 30 minuti",
      callEndedError: "Un errore ha terminato la chiamata",
      callHangUp: "Riaggancia",
      callLevel: "Livello del microfono",
      callYou: "Lei",
      callSpeaking: "Il bot sta parlando …",
      callThinking: 'La risposta è in generazione …',
      callOvertaken: "superata dalla sua domanda successiva, non pronunciata",
      callNothingHeard: "Non è stata ascoltata alcuna parola.",
      callMicDenied: "Il browser ha rifiutato il microfono; lo consenta per questa pagina e richiami.",
      callNoVoice: "La voce non è disponibile al momento; la risposta resta come testo.",
      callRefused: "La chiamata non è stata accettata: il biglietto non era valido o era scaduto; richiami.",
      callFailed: "La chiamata non è riuscita",
      voice: "Voce",
      voiceHint: "La voce con cui parla questo collega: in Webex, quando una persona chiede di ascoltare la risposta, e al telefono. Per impostazione predefinita è un parlante del modello audio su OpenRouter; una voce propria, clonata, dell'archivio voci parla tramite il motore vocale della piattaforma.",
      voiceSave: "Salva voce",
      voiceDefault: "predefinita",
      voiceNone: "nessuna voce",
      voiceCloud: "Parlanti OpenRouter (predefinito)",
      voiceOwn: "Voci proprie (clonate)",
      voiceUploadTitle: "Carica un campione di voce per questo collega",
      voiceUploadHint: "Audio o video, al massimo 25 MB; il Core converte il campione, ne conserva fino a 20 secondi, ne ascolta le parole e salva solo la clip di riferimento. Il collega parla subito con questa voce.",
      voiceUploadName: "Nome della voce",
      voiceUploadConsent: "Confermo di avere il diritto di usare questa voce per l’azienda: è la mia, oppure la persona ha dato il consenso.",
      voiceUploadButton: "Carica campione",
      voiceUploadDone: "Voce salvata",
      voiceTooLarge: "Il file supera i 25 MB.",
      voicesTitle: "Voci",
      voicesSubtitle: "Ogni voce dell’azienda è una clip di riferimento nell’archivio voci di Veridion Core; il motore vocale la clona ogni volta che un bot parla. I nove parlanti precedenti vi stanno come clip catturate.",
      voiceSeconds: "Secondi",
      voiceSource: "Origine",
      voiceSourcePreset: "parlante catturato",
      voiceSourceUpload: "campione caricato",
      voiceAddedBy: "Aggiunta da",
      voiceConsentBy: "Consenso confermato da",
      voiceWords: "Parole della clip",
      voiceDelete: "Elimina",
      voiceConfirmDelete: "Eliminare questa voce? I colleghi che la usano torneranno a parlare con la loro voce predefinita.",
      voiceCapture: "Cattura i parlanti del motore a preset",
      voiceCaptureHint: "Pronuncia una frase fissa per parlante tramite il motore a preset e la salva come clip; si esegue prima del cambio di motore.",
      voiceCaptured: "Catturate",
      voiceEnginePresets: "Il motore vocale offre parlanti fissi; l’archivio voci non è usato.",
      chartTitle: "Organigramma",
      executiveTitle: 'Livello direttivo',
      unitsTitle: 'Unità di business',
      unitLead: 'Responsabile',
      unitSupporting: 'Con il supporto di',
      unitMission: 'Missione',
      unitPrefix: 'Prefisso del thread',
      standingActive: 'attivo',
      standingStandby: 'in standby',
      standbyOn: 'Metti in standby',
      standbyOff: 'Attiva',
      standbyHint: 'In standby un collega non prende alcun turno su iniziativa dell\'azienda e non costa token; un messaggio diretto di una persona riceve comunque risposta.',
      confirmStandby: 'Mettere {name} in standby?',
      confirmActivate: 'Attivare {name}?',
      activity: 'Attività',
      runtime: 'Ambiente di esecuzione',
      modelCloud: 'modello cloud',
      modelGpu: 'motore aziendale',
      callModel: 'Modello telefonico',
      calls30: 'Chiamate, ultimi 30 giorni',
      telemetryLine: '{model} · {prompt}+{completion} token · {cost} · orecchio {asr} ms · mente {llm} ms · voce {tts} ms · totale {total} ms{deferred}',
      telemetryDeferred: ' · {count} rinviati',
      chartSubtitle: "I colleghi IA di Veridion: agenti in Veridion Core, ciascuno raggiungibile come proprio bot Webex, per area; sopra i decisori umani, sotto gli agenti senza un bot proprio e gli spazi aziendali, letti in diretta da Veridion Core e Webex.",
      chartPeople: "Decisori",
      chartPeopleText: "I decisori umani decidono tutto e agiscono in {space}.",
      chartAgentsTitle: "Agenti senza un bot proprio: l'agente di programmazione, l'orchestratore MCP di Veridion e gli agenti costruiti dall'architetto lavorano per conto di un collega IA e parlano attraverso il suo bot",
      chartDesigned: "Agenti progettati con l'architetto",
      chartFor: "Per conto di",
      chartSystemsTitle: "Sistemi collegati",
      chartSpaceHome: "Spazio di riferimento di",
      chartSpacePurpose: "Scopo",
      chartRoomsTitle: "Spazi aziendali in Webex",
      room: "Spazio",
      roomBots: "Bot",
      positionsTitle: "Colleghi IA",
      positionsSubtitle: "Ogni collega IA risponde con il proprio bot e legge i suoi spazi. La sua descrizione è l'istruzione con cui lavora.",
      bot: "Bot",
      position: "Funzione",
      statusLabel: "Stato",
      tokensUsed: "Token utilizzati",
      tokens30: "Token, ultimi 30 giorni",
      edit: "Modifica",
      close: "Chiudi",
      description: "Descrizione del collega IA",
      save: "Salva",
      resetDescription: "Ripristina la descrizione predefinita",
      interests: "Profilo di interessi",
      interestsHint: "Quali tipi di punti e quali temi riguardano questo collega IA e quando non lo riguardano. Il collega IA valuta ogni messaggio dei suoi spazi in base a questo.",
      threshold: 'Soglia per gli interventi non richiesti',
      thresholdHint: 'Da 1 a 5: quanto un messaggio deve riguardare il collega IA prima che intervenga senza essere interpellato. Con 1 interviene già a bassa rilevanza, con 5 solo ad alta rilevanza.',
      saveProfile: "Salva profilo",
      tools: "Strumenti",
      decisionMakersTitle: "Decisori",
      decisionMakersSubtitle: "Ognuno di loro può dare qualsiasi approvazione e rispondere a qualsiasi domanda di un collega IA in Webex.",
      email: "Indirizzo e-mail",
      add: "Aggiungi",
      remove: "Rimuovi",
      confirmRemove: "Rimuovere questo decisore?",
      readerTitle: "Lettura degli spazi aziendali",
      readerSubtitle: "Un bot vede solo i messaggi che lo menzionano. Veridion legge ogni messaggio degli spazi aziendali tramite l'autorizzazione di un account che è membro di tutti.",
      notConfigured: "L'integrazione non è configurata",
      authorised: "Autorizzato",
      notAuthorised: "Non autorizzato",
      account: "Account",
      validUntil: "Token di accesso valido fino al",
      renewUntil: "Autorizzazione rinnovabile fino al",
      authorise: "Autorizza la lettura",
      authoriseAgain: "Autorizza di nuovo",
      linkOpened: "L'accesso a Webex si è aperto in una nuova scheda.",
      found: "trovato",
      notFound: "non trovato",
      botsInSpace: "bot",
      transcripts: "Trascrizioni delle riunioni",
      yes: "sì",
      no: "no",
      approvalsTitle: "Approvazioni aperte",
      approvalsSubtitle: "Approvazioni e domande richieste dai colleghi IA a cui nessun decisore ha ancora risposto.",
      originSpace: "Spazio",
      directRoom: "conversazione diretta",
      approvalKinds: { review: "approvazione", question: "domanda" },
      schedulesTitle: "Pianificazioni",
      schedulesSubtitle: "Lavoro ricorrente richiesto in uno spazio; continua finché qualcuno non lo termina.",
      createdBy: "richiesto da",
      lastRun: "ultima esecuzione",
      end: "Termina",
      confirmEnd: "Terminare questa pianificazione?",
      none: "Nessuno",
      loading: "Caricamento…",
      failed: "Non riuscito",
      working: "In corso…",
      done: "Fatto",
      memoryTitle: "Organizzazione",
      memorySubtitle: "Le persone e i colleghi IA dell'azienda con l'ambito di memoria in cui lavora ogni collega IA.",
      memoryMember: "Membro",
      area: "Area",
      decisionMaker: "Decisore",
      status: { running: "attivo" },
    },
    core: {
      conversationTitle: 'Conversazione dal dashboard',
      conversationHint: 'Ogni messaggio e ogni risposta vengono detti anche in Webex: nel thread del lavoro dell\'agente, altrimenti nella sua stanza diretta con il bot.',
      conversationEmpty: 'Ancora nessun messaggio dal dashboard.',
      writeToAgent: 'Messaggio a questo agente',
      answerPending: 'Risposta in attesa',
      title: 'Veridion Core',
      subtitle: 'Il sistema operativo agentico dietro il bot aziendale: i suoi agenti, i loro messaggi e consumo di token, le definizioni, l\'architetto e l\'organizzazione.',
      done: 'Fatto.',
      failed: 'Non è riuscito',
      loading: 'Caricamento …',
      working: 'Elaborazione …',
      none: 'Nessuno.',
      unavailable: 'Veridion Core non è raggiungibile',
      errors: {
        AGENT_FINISHED: 'L\'agente ha terminato e non accetta più messaggi',
        EMERGENCY_STOP: 'L\'arresto di emergenza è attivo',
        DEFINITION_INVALID: 'La definizione non è valida',
        TOO_MANY_AGENTS: 'Sono in esecuzione troppi agenti',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core non è configurato',
        MESSAGE_EMPTY: 'Il messaggio è vuoto',
      },
      status: {
        building: 'creazione dell\'immagine',
        starting: 'in avvio',
        running: 'in esecuzione',
        waiting: 'in attesa',
        idle: 'pronto',
        paused: 'in pausa',
        completed: 'completato',
        failed: 'non riuscito',
        cancelled: 'annullato',
        stopped: 'arrestato',
        not_deployed: 'non distribuito',
      },
      statusLabel: 'Stato',
      owner: 'Proprietario',
      definition: 'Definizione',
      parent: 'Agente padre',
      tokens: 'Token',
      progress: 'Avanzamento',
      close: 'Chiudi',
      openQuestion: 'Domanda aperta',
      result: 'Risultato',
      answerQuestion: 'Rispondi alla domanda',
      sendMessage: 'Messaggio all\'agente',
      urgent: 'Urgente: interrompi il passo corrente',
      send: 'Invia',
      messageSent: 'Consegnato all\'agente.',
      commands: {
        pause: 'Metti in pausa',
        resume: 'Riprendi',
        cancel: 'Annulla',
        kill: 'Termina subito',
      },
      confirmKill: 'Terminare subito questo agente e i suoi sotto-agenti?',
      subAgents: 'Sotto-agenti',
      graph: 'Grafo',
      messages: 'Messaggi',
      messageStatus: {
        queued: 'in coda',
        delivered: 'consegnato',
        consumed: 'letto',
        refused: 'rifiutato',
      },
      events: 'Eventi',
      containerLog: 'Log del container',
      version: 'Versione',
      activeAgents: 'Agenti attivi',
      updated: 'Aggiornato',
      archived: 'archiviato',
      noDefinitions: 'Ancora nessuna definizione.',
      versions: 'Versioni',
      from: 'da',
      startInput: 'Input iniziale in JSON',
      agentStarted: 'Agente avviato.',
      startAgent: 'Avvia agente',
      editAsJson: 'Modifica come JSON',
      confirmArchive: 'Archiviare questa definizione? Gli agenti in esecuzione continuano a funzionare.',
      archive: 'Archivia',
      definitionJson: 'Definizione in JSON',
      definitionJsonHint: 'Una definizione nel linguaggio a grafi di Veridion. Convalida mostra i suoi problemi e il suo grafo; il salvataggio la memorizza come nuova versione approvata.',
      checked: 'Verificato.',
      validate: 'Convalida',
      saved: 'Salvato come nuova versione.',
      saveVersion: 'Salva come nuova versione',
      valid: 'La definizione è valida.',
      you: 'Lei',
      architect: 'Architetto',
      architectPlaceholder: 'Descriva che cosa deve fare l\'agente …',
      newDesign: 'Nuova progettazione',
      unitKinds: {
        company: 'azienda',
        department: 'reparto',
        team: 'team',
        project: 'progetto',
      },
      partOf: 'parte di',
      confirmRemove: 'Rimuovere questa unità? I suoi membri perdono questo ambito.',
      remove: 'rimuovi',
      addUnit: 'Aggiungi un\'unità',
      unitId: 'ID (minuscole, trattini)',
      unitName: 'Nome',
      add: 'Aggiungi',
      addMember: 'Aggiungi un membro',
      memberKinds: {
        person: 'persona (indirizzo e-mail)',
        agent: 'agente (ID)',
        definition: 'definizione (ID)',
      },
      memberId: 'Indirizzo e-mail o ID',
      role: 'Ruolo',
      confirmEmergencyOn: 'Arrestare ora tutti gli agenti? Il bot continua a rispondere.',
      confirmEmergencyOff: 'Rilasciare l\'arresto di emergenza?',
      emergencyStop: 'Arresto di emergenza',
      emergencyRelease: 'Rilascia arresto di emergenza',
      emergencyActive: 'arresto di emergenza attivo',
      autopilotOn: 'Attivare il pilota automatico',
      autopilotOff: 'Disattivare il pilota automatico',
      autopilotActive: 'Pilota automatico attivo: Veridion Core risponde da sé a ogni scheda rivolta alle persone',
      autopilotUnitsTitle: 'Pilota automatico per business unit',
      autopilotUnitsHint: 'Attiva o disattiva il pilota automatico singolarmente per ogni business unit e per il livello esecutivo. Il lavoro sospeso non viene mai toccato.',
      autopilotUnitOn: 'Autopilota attivo',
      autopilotUnitOff: 'Autopilota spento',
      limitsBuilds: 'Build di immagini per collega e giorno',
      limitsDesigns: 'Progetti di agenti per collega e giorno',
      limitsSave: 'Imposta i limiti giornalieri',
      limitsNone: '0 = nessun limite',
      confirmAutopilotOn: 'Attivare il pilota automatico? Il decisore proprio di Veridion Core risponde subito a ogni scheda aperta e a ogni nuova scheda in pAIoneer-humans-and-bots, visibilmente nel thread della scheda.',
      confirmAutopilotOff: 'Disattivare il pilota automatico? Da quel momento decidono di nuovo le persone.',
      model: 'Modello',
      codingModel: 'Modello di programmazione',
      modelsTitle: 'Modelli per ruolo',
      modelsSubtitle: 'Su quale modello pensa ogni ruolo di Veridion Core: il volto e la guida dell\'azienda, il telefono, l\'architetto e il giudice dei verdetti sui requisiti. Si possono scegliere solo i modelli instradati dal gateway; vuoto significa il valore predefinito della configurazione.',
      roleCoordinator: 'Coordinatore (volto e guida)',
      roleCall: 'Telefono',
      roleArchitect: 'Architetto',
      roleRequirementsJudge: 'Giudice dei requisiti',
      roleJudge: 'Giudizi del Core',
      roleEar: 'Orecchio del telefono',
      roleStt: 'Orecchio Webex',
      modelGroupVllm: 'vLLM (scheda propria)',
      modelGroupAudio: 'Audio (scheda propria / cloud)',
      modelGroupCloud: 'OpenRouter (cloud)',
      directLlmTitle: 'Accesso diretto al LLM',
      directLlmSubtitle: 'Parla direttamente con un vLLM o un modello cloud, senza bot, agenti o Webex',
      directLlmHint: 'Accesso diretto amministratore: il modello scelto risponde grezzo, contabilizzato come “console”, senza lane, ruoli o strumenti.',
      directLlmModel: 'Modello',
      directLlmSystem: 'Prompt di sistema (facoltativo)',
      directLlmSystemPlaceholder: 'es. Sei …',
      directLlmPrompt: 'Messaggio',
      directLlmPromptPlaceholder: 'Cosa vuoi chiedere direttamente al modello?',
      directLlmSend: 'Invia',
      directLlmSending: 'Invio …',
      directLlmUsage: '{prompt}+{completion} token · {cost}',
      modelCurrent: 'In uso',
      modelDefault: 'Predefinito',
      modelChosen: 'Scelto',
      modelDefaultOption: 'il valore predefinito della configurazione',
      modelNotRouted: 'non instradato dal gateway',
      modelSave: 'Salva',
      engineSilver: 'Motore aziendale (argento)',
      engineGold: 'Motore aziendale (oro, dell\'orchestratore)',
      callsTitle: 'Chiamate telefoniche',
      callsSubtitle: 'Ogni turno parlato del telefono, contabilizzato a parte dal lavoro dei colleghi: token, costo e il tempo di orecchio, mente e voce, per collega e modello, per gli ultimi 30 giorni e oggi; sotto, i turni più recenti.',
      callsTurns: 'Turni',
      callsCalls: 'Chiamate',
      callsAvgTotal: 'Ø totale ms',
      callsAvgAsr: 'Ø orecchio ms',
      callsAvgLlm: 'Ø mente ms',
      callsAvgTts: 'Ø voce ms',
      callsDeferred: 'Rinviati',
      callsToday: 'Oggi',
      callsWindow: 'Ultimi 30 giorni',
      callsRecent: 'Turni più recenti',
      callsPerson: 'Persona',
      callsRounds: 'Round',
      callsNone: 'Nessuna chiamata contabilizzata finora.',
      unitKindExecutive: 'Livello direttivo',
      unitKindBusinessUnit: 'Unità di business',
      orgSynced: 'Il livello direttivo e le unità di business sono definiti nell\'organizzazione di Veridion Core e sincronizzati qui; si modificano lì, non in questa pagina.',
      memory: 'Memoria',
      ready: 'pronto',
      notReady: 'non pronto',
      factExtraction: 'estrazione dei fatti attiva',
      cluster: 'Accesso al cluster',
      agentsRunning: 'Agenti in esecuzione',
      agentsWaiting: 'in attesa',
      definitions: 'Definizioni',
      gatewayIdentity: 'Identità sul gateway',
      gatewayTokens: 'Token del gateway nella finestra temporale',
      hostedTitle: 'Agenti ospitati',
      hostedSubtitle: 'Applicazioni di IA che Veridion Core avvia e gestisce in container propri.',
      agent: 'Agente',
      actions: 'Azioni',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'avvia',
        stop: 'arresta',
        restart: 'riavvia',
      },
      open: 'apri',
      agentsTitle: 'Agenti',
      agentsSubtitle: 'Ogni agente e sotto-agente viene eseguito in un container proprio. Ne apra uno per inviargli messaggi o impartirgli comandi.',
      showFinished: 'Mostra agenti terminati',
      noAgents: 'Nessun agente.',
      definitionsTitle: 'Definizioni',
      definitionsSubtitle: 'Grafi di agenti approvati con le loro versioni.',
      designsTitle: 'Progetti di agenti',
      designsSubtitle: 'Ogni agente progettato dall\'architetto, per una persona o per il lavoro di un collega IA: a cosa serve e perché, ogni domanda con la risposta, i test rispetto agli scenari, l\'approvazione e le esecuzioni.',
      design: 'Progetto',
      designFor: 'Per',
      designWork: 'Lavoro',
      designState: 'Stato',
      designApprovedBy: 'Approvato da',
      designAgent: 'Agente costruito',
      filterState: 'Stato',
      filterAll: 'Tutti',
      filterOpen: 'Aperti',
      filterDone: 'Completati',
      filterFailed: 'Falliti',
      filterCurrent: 'Attivi e falliti di recente',
      filterActive: 'Attivi',
      filterFinished: 'Terminati',
      filterPosition: 'Collega IA',
      pagePrev: 'Precedente',
      pageNext: 'Successiva',
      pageLabel: 'Pagina',
      searchLabel: 'Cerca',
      showMore: 'Mostra altro',
      noDesigns: 'Nessun agente ancora progettato.',
      designReason: 'Perché gli strumenti non bastavano',
      designRecord: 'Registro',
      designAgents: 'Agenti del progetto',
      designTestRun: 'Test',
      designRun: 'Esecuzione',
      designStatus: { designing: 'in progettazione', testing: 'in test', asking: 'attende una risposta', approval: 'attende l\'approvazione', running: 'in esecuzione', done: 'completato', failed: 'fallito', cancelled: 'annullato' },
      builtBy: 'Costruito da',
      builtFor: 'Per il lavoro',
      viaCodingTask: 'tramite l\'agente di programmazione',
      designTests: 'Test',
      designRuns: 'Esecuzioni',
      designByPerson: 'una persona in conversazione',
      diagramsTitle: 'Diagrammi',
      diagramsSubtitle: 'Immagini di flussi, architetture e piani disegnate da colleghi IA, agenti e dall\'agente di programmazione, con titolo, legenda e codice Mermaid.',
      noDiagrams: 'Ancora nessun diagramma.',
      diagramAuthor: 'Autore',
      diagramBasedOn: 'Estende',
      diagramCode: 'Codice Mermaid',
      architectTitle: 'Architetto',
      architectSubtitle: 'Progetti un agente conversando. L\'architetto chiede ciò che non può stabilire da solo e crea l\'agente solo dopo la Sua approvazione.',
      orgTitle: 'Organizzazione',
      orgSubtitle: 'Reparti, team e progetti con i loro membri; la memoria aziendale è condivisa lungo questa struttura.',
      usageTitle: 'Consumo per agente',
      usageSubtitle: 'Chiamate ai modelli, token e costi rilevati negli ultimi 30 giorni.',
      calls: 'Chiamate',
      source: 'Origine',
      gpuTokens: 'Token sulla scheda grafica',
      cloudTokens: 'Token nel cloud',
      usageByModel: 'Per collega e modello',
      cost: 'Costo',
    },
    memory: {
      archOverviewTitle: "Panoramica dell'architettura: come è costruita la memoria aziendale",
      archOverviewText: "Veridion Core conserva il sapere aziendale in tre strati: Neo4j come grafo di conoscenza temporale per fatti, decisioni e pacchetti di lavoro, PostgreSQL per gli stati transazionali di agenti, caselle e sprint e Qdrant per la ricerca vettoriale sui documenti aziendali. Ogni business unit lavora in un dominio di conoscenza isolato; i risultati tra unità passano per consegne registrate.",
      clustersTitle: "Domini di conoscenza delle business unit",
      clustersSubtitle: "Ogni business unit lavora in un dominio di conoscenza Neo4j delimitato; i conteggi di nodi e archi arrivano in diretta da Neo4j, le descrizioni dal popolamento iniziale contrassegnato. Un clic apre il dominio nel grafo della conoscenza.",
      clusterCode: "Sigla",
      clusterName: "Dominio di conoscenza",
      clusterId: "Identificativo",
      clusterRoles: "Ruoli",
      clusterBridges: "Ponti di consegna",
      clusterPolicy: "Focus tematico & regola di isolamento",
      clusterCounts: "Nodi / archi (in diretta)",
      clusterInsights: "Constatazioni (popolamento iniziale)",
      clusterOpenButton: "Apri nel grafo della conoscenza",
      countsUnavailable: "Neo4j non raggiungibile — nessun conteggio",
      researchTitle: "Archivio di ricerca IA quantistica & frontier",
      researchSubtitle: "Pubblicazioni scientifiche fondamentali & riferimenti architetturali — righe in diretta da Veridion Core; l'origine di ogni riga è visibile.",
      researchEmpty: "Ancora nessuna pubblicazione nell'archivio.",
      researchIngestNote: "Le nuove pubblicazioni le aggiunge il collega quantistico tramite il suo strumento; il cruscotto si limita a leggere l'archivio.",
      researchPublication: "Pubblicazione",
      researchMechanism: "Meccanismo chiave",
      researchRelevance: "Rilevanza per l'architettura",
      researchOrigin: "Origine",
      researchSeeded: "popolamento iniziale",
      researchMotivates: "Motiva la versione",
      title: 'Memoria aziendale',
      subtitle: 'Ciò che Veridion Core conserva in Neo4j: ricordi per ambito, fatti con il loro periodo di validità e l\'audit di ciò che hanno fatto gli agenti.',
      failed: 'Non è riuscito',
      loading: 'Caricamento …',
      unavailable: 'La memoria non è raggiungibile',
      database: 'Database',
      ready: 'pronto',
      notReady: 'non pronto',
      factExtraction: 'Estrazione dei fatti',
      episodesQueued: 'Episodi in attesa',
      lastError: 'Ultimo errore',
      contentTitle: 'Contenuto',
      contentSubtitle: 'Nodi per label e ricordi per ambito e tipo.',
      label: 'Label',
      count: 'Numero',
      empty: 'Ancora niente.',
      scope: 'Ambito',
      kind: 'Tipo',
      kinds: {
        fact: 'fatto',
        decision: 'decisione',
        task: 'attività',
        procedure: 'procedura',
        note: 'nota',
        episode: 'episodio',
      },
      searchTitle: 'Ricerca',
      searchSubtitle: 'Il recupero usato dagli agenti: significato, parole e fatti estratti.',
      searchPlaceholder: 'Termine di ricerca o domanda',
      allScopes: 'tutti gli ambiti',
      search: 'Cerca',
      noResults: 'Nessun risultato.',
      text: 'Testo',
      validFrom: 'Valido dal',
      source: 'Fonte',
      extracted: 'estratto',
      recorded: 'registrato',
      rememberTitle: 'Memorizza',
      rememberSubtitle: 'Salvare un fatto, una decisione, un\'attività, una procedura o una nota in un ambito.',
      remembered: 'Salvato.',
      remember: 'Memorizza',
      created: 'Creato',
      validity: 'Validità',
      invalid: 'non valido',
      confirmInvalidate: 'Contrassegnare questo ricordo come non più valido?',
      invalidate: 'contrassegna come non valido',
      forget: 'dimentica',
      confirmForget: 'Dimenticare definitivamente questa voce? Viene eliminata dalla memoria e non può essere ripristinata.',
      forgotten: 'Dimenticato.',
      factsTitle: 'Fatti nel tempo',
      factsSubtitle: 'Fatti estratti dalle conversazioni e dai risultati degli agenti; un fatto smentito riceve una data di fine.',
      noFacts: 'Ancora nessun fatto estratto.',
      briefsTitle: 'Sintesi dei colleghi IA',
      briefsSubtitle: 'Ciò che ogni collega IA legge per primo: impegni aperti, decisioni valide, attività in corso e clienti, scritto ogni notte dalla memoria.',
      brief: 'Sintesi',
      updated: 'Aggiornato',
      noBriefs: 'Ancora nessuna sintesi scritta.',
      fact: 'Fatto',
      from: 'Da',
      to: 'A',
      validUntil: 'Valido fino al',
      stillValid: 'ancora valido',
      entityTitle: 'Contesto',
      entitySubtitle: 'A che cosa sono collegati un\'attività, un progetto, una persona, un sistema o un\'entità.',
      entityPlaceholder: 'Nome, ID attività, indirizzo e-mail o ID',
      show: 'Mostra',
      auditTitle: 'Audit',
      auditSubtitle: 'Chiamate a modelli e strumenti, messaggi e sotto-agenti avviati.',
      auditPlaceholder: 'ID agente (vuoto: tutti)',
      filter: 'Filtra',
      time: 'Ora',
      agent: 'Agente',
      event: 'Evento',
      toolOrModel: 'Strumento o modello',
      status: 'Stato',
      detail: 'Dettaglio',
      consoleTitle: 'Console di query',
      consoleSubtitle: 'Cypher in sola lettura; le istruzioni di scrittura vengono rifiutate.',
      run: 'Esegui',
      truncated: 'altre righe troncate',
      graph: {
        clusterPickTitle: "Mettere a fuoco un dominio di conoscenza nel grafo",
        clusterPickHint: "Un clic su una business unit mette a fuoco il suo sottografo con ruoli e ponti di consegna nel grafo interattivo.",
        allClusters: "Tutti i domini (grafo completo)",
        activeCluster: "Dominio di conoscenza attivo",
        publicationsTitle: "Pubblicazioni nell'archivio di ricerca",
        storesTitle: 'Archivi della memoria aziendale',
        storesSubtitle: 'Che cosa contiene ogni archivio della memoria aziendale, letto in tempo reale: il grafo in Neo4j, lo stato di Veridion Core in Postgres, i vettori della base di conoscenza in Qdrant.',
        storeNeo4j: 'Neo4j (grafo)',
        storeNeo4jHolds: 'La memoria aziendale: i ricordi con il loro ambito, le entità e i fatti estratti da Graphiti con il loro periodo di validità, gli elementi di lavoro con il loro significato, il lavoro software e l\'audit degli agenti.',
        storePostgres: 'Postgres (relazionale)',
        storePostgresHolds: 'Lo stato transazionale di Veridion Core: la tabella dei processi degli agenti, le caselle di posta, le conversazioni, i checkpoint, i compiti di codifica, le approvazioni, l\'organizzazione e i consumi.',
        storeQdrant: 'Qdrant (vettori)',
        storeQdrantHolds: 'La base di conoscenza aziendale: i passaggi vettorizzati dei documenti aggiunti da un amministratore, interrogati dall\'orchestratore quando un turno di conversazione ha bisogno della base di conoscenza.',
        nodes: 'nodi',
        relationships: 'relazioni',
        relationshipType: 'Tipo di relazione',
        tables: 'tabelle',
        table: 'Tabella',
        rows: 'righe',
        purpose: 'Che cosa contiene',
        documents: 'documenti',
        session: 'Sessione',
        collection: 'Collezione',
        role: 'Ruolo',
        roleDocuments: 'documenti',
        roleCurated: 'coppie domanda-risposta curate',
        title: 'Grafo',
        subtitle: 'Il grafo della memoria aziendale in Neo4j: parti da un risultato di ricerca, dai ricordi più recenti o dagli elementi di lavoro; clicca un nodo per leggerlo, espandi i suoi vicini, trascina per ordinare, scorri per ingrandire.',
        startNewest: 'Ricordi più recenti',
        startWork: 'Elementi di lavoro',
        searchPlaceholder: 'Nome, testo o id da trovare nel grafo',
        find: 'Cerca',
        noHits: 'Nessun risultato.',
        name: 'Nome',
        sources: { memory: 'ricordo', entity: 'entità estratta', node: 'memoria di progetto', episode: 'episodio' },
        show: 'mostra',
        shown: '{nodes} nodi e {edges} relazioni nel grafo',
        truncated: 'tagliato al limite; espandi un nodo o cerca in modo più preciso',
        selected: 'Nodo selezionato',
        selectHint: 'Clicca un nodo nel grafo.',
        expand: 'Espandi i vicini',
        expandTwo: 'Espandi due livelli',
        centre: 'Centra su questo nodo',
        facts: 'Fatti di questa entità',
        degree: 'Relazioni',
        direction: 'Direzione',
        out: 'in uscita',
        in: 'in entrata',
        noRelationships: 'Nessuna relazione.',
        property: 'Proprietà',
        value: 'Valore',
        noProperties: 'Nessuna proprietà.',
        factsOf: 'Fatti di',
        factsSubtitle: 'Che cosa Graphiti ha estratto su questa entità, con il periodo in cui ogni fatto vale; un fatto contraddetto porta una data di fine.',
        relation: 'Relazione',
        other: 'Altra entità',
        newestTitle: 'Ricordi più recenti',
        newestSubtitle: 'Gli ultimi ricordi scritti, con il loro oggetto; «mostra» ne disegna uno con i suoi collegamenti.',
        about: 'Oggetto',
        workTitle: 'Elementi di lavoro',
        workSubtitle: 'Ogni lavoro confermato con stato, responsabile, ticket e i risultati dei suoi scenari; «mostra» ne disegna uno con il suo significato, il suo ticket, i suoi compiti di codifica e gli agenti costruiti per esso.',
        allStates: 'tutti gli stati',
        states: { confirmed: 'confermato', in_progress: 'in corso', blocked: 'bloccato', done: 'concluso', failed: 'fallito', dropped: 'abbandonato' },
        workItem: 'Elemento di lavoro',
        owner: 'Responsabile',
        issue: 'Ticket',
        scenarios: 'Scenari',
        results: { passed: 'superato', failed: 'fallito', pending: 'in sospeso' },
      },
      day: {
        title: 'La giornata dell\'azienda',
        subtitle: 'La cronologia degli eventi che Veridion Core registra: le parole delle persone, le schede, il lavoro, i passaggi di consegne, le ricerche, gli agenti, i compiti di codifica, i progetti, gli incidenti e le riunioni, dal più recente.',
        sinceToday: 'oggi',
        sinceDay: 'ultime 24 ore',
        sinceWeek: 'ultimi 7 giorni',
        allKinds: 'tutti i tipi',
        refresh: 'Aggiorna',
        count: '{n} eventi',
        time: 'Ora',
        actor: 'Attore',
        happening: 'Evento',
        work: 'Lavoro',
        empty: 'Nulla registrato in questo periodo.',
        kinds: { word: 'parola', request: 'richiesta', card: 'scheda', work: 'lavoro', handover: 'passaggio di consegne', research: 'ricerca', agent: 'agente', task: 'compito di codifica', project: 'progetto', incident: 'incidente', schedule: 'pianificazione', meeting: 'riunione', message: 'messaggio' },
      },
    },
    title: 'Pannello di amministrazione',
    adminKicker: 'Operazioni',
    smtmStatusTitle: 'Dati e previsioni SMTM',
    smtmStatusSubtitle: 'Monitora le serie temporali del broker, i modelli pubblicati, l\'output di previsione e i feed RSS.',
    smtmStatusUnavailable: 'Stato SMTM non disponibile',
    smtmGeneratedAt: 'Generato il',
    smtmMinimumRows: 'Righe minime di addestramento',
    smtmBaseFrames: 'Serie temporali di base',
    smtmTrainableFrames: 'Dati grezzi pronti',
    smtmWaitingHistory: 'In attesa di storico',
    smtmPredictionTrackedInstruments: 'Strumenti monitorati',
    smtmPredictionEnabledCount: 'Previsioni attive',
    smtmPredictionDisabledCount: 'Previsioni in pausa',
    smtmMlFrames: 'Set di dati ML',
    smtmOnlineModels: 'Modelli online',
    smtmModelsWithArtifacts: 'Modelli con artefatti',
    smtmPredictionFrames: 'Serie di previsione',
    smtmMissingPredictions: 'Serie senza previsioni',
    smtmBlobArtifacts: 'Artefatti blob',
    smtmStalePredictions: 'Previsioni obsolete',
    smtmRssFrames: 'Feed RSS',
    smtmDataframesTotal: 'Set di dati totali',
    smtmLatestModelUpload: 'Ultimo caricamento di modello',
    smtmLatestPredictionWrite: 'Ultima scrittura di previsione',
    smtmRuntimeHints: 'Avvisi di runtime',
    smtmNoHints: 'Nessun avviso SMTM aperto.',
    smtmInstrument: 'Strumento',
    smtmBaseData: 'Dati di base',
    smtmMlFrame: 'Set di dati ML',
    smtmModelPublish: 'Stato del modello',
    smtmArtifacts: 'Artefatti',
    smtmPredictionFrame: 'Serie di previsione',
    smtmIssues: 'Problemi',
    smtmNoIssues: 'Nessun problema',
    smtmNoFrames: 'Nessuno strumento SMTM trovato.',
    smtmPredictionControlTitle: 'Controllo previsioni SMTM',
    smtmPredictionControlSubtitle: 'Decidi per ogni strumento se SMTM deve calcolare nuove previsioni di machine learning o limitarsi a raccogliere dati di base.',
    smtmPredictionSettingsUnavailable: 'Controllo previsioni SMTM non disponibile',
    smtmPredictionControlHint: 'Gli strumenti in pausa mantengono i dati storici. Per loro non vengono più generati set ML, addestramenti né previsioni.',
    smtmPredictionMode: 'Modalità di previsione',
    smtmPredictionToggle: 'Controllo amministratore',
    smtmPredictionToggleLabel: 'Attiva o metti in pausa le previsioni',
    smtmPredictionEnabled: 'Previsione attiva',
    smtmPredictionDisabled: 'Previsione in pausa',
    smtmPredictionSaving: 'Salvataggio...',
    smtmPredictionSettingsSaved: 'Controllo previsioni SMTM salvato.',
    smtmPredictionSaveChanges: 'Salva modifiche',
    smtmPredictionResetChanges: 'Annulla modifiche',
    smtmPredictionPendingChanges: 'modifiche in sospeso',
    smtmPredictionPendingBadge: 'Salvataggio in sospeso',
    smtmOpenAzuriteUi: 'Apri l\'interfaccia web di Azurite',
    azuriteTitle: 'Interfaccia web Azurite (SMTM)',
    azuriteSubtitle: 'Vista in sola lettura per le voci modelstatus, gli artefatti blob e i download dei modelli.',
    azuriteModelGroups: 'Gruppi di modelli',
    azuriteBlobArtifacts: 'Artefatti blob',
    azuriteFiles: 'File',
    azuriteSearchPlaceholder: 'Filtra modelli',
    azuriteNoModels: 'Nessun modello Azurite trovato.',
    smtmRows: 'Righe',
    smtmLatest: 'Ultimo timestamp',
    smtmAge: 'Età',
    smtmValue: 'Valore',
    smtmMinutesAgo: 'min fa',
    smtmMinutesAhead: 'min avanti',
    smtmHoursAgo: 'h fa',
    smtmDaysAgo: 'g fa',
    smtmStateLabels: {
      available: 'Disponibile',
      trainable: 'Addestrabile',
      waiting_for_history: 'In attesa di storico',
      missing_base_data: 'Nessun dato di base',
      missing_machine_learning: 'Set di dati ML mancante',
      missing_prediction: 'Previsione mancante',
      prediction_disabled: 'Previsione in pausa',
      stale_prediction: 'Previsione obsoleta',
      open: 'Aperta',
      completed: 'Completata',
      online: 'Online',
      offline: 'Offline',
      training: 'Addestramento',
      uploading: 'Caricamento',
      failed: 'Fallita',
      unknown: 'Sconosciuto',
      missing: 'Mancante'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Serie temporale di base vuota',
      insufficient_history: 'Storico insufficiente',
      missing_machine_learning_frame: 'Set di dati ML mancante',
      missing_prediction_frame: 'Serie di previsione mancante',
      stale_prediction_frame: 'Serie di previsione obsoleta',
      missing_online_model: 'Nessun modello online',
      model_offline: 'Modello offline',
      missing_model_blob: 'Blob del modello mancante',
      missing_model_header: 'Intestazione del modello mancante',
      missing_modelstatus_entry: 'Voce modelstatus mancante',
      inference_not_writing_prediction: 'L\'inferenza non scrive previsioni',
      prediction_disabled_by_admin: 'Previsione messa in pausa dall\'amministratore'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'strumenti pronti senza output di previsione',
      instruments_waiting_for_history: 'strumenti ancora in attesa di storico',
      models_missing_artifacts: 'modelli online senza artefatti completi',
      no_online_models: 'Nessun modello online in Azurite',
      azurite_unavailable: 'Lo stato dello storage Azurite non è al momento disponibile'
    },
    mailTitle: 'Configurazione della posta',
    usersTitle: 'Gestione utenti',
    usersSubtitle: 'Account, ruoli, stato e 2FA da Keycloak. Selezionandone uno si aprono i comandi per quell\'account.',
    usersHideCreate: 'Chiudi modulo',
    usersCreateHint: 'Un nuovo account parte con 2FA obbligatoria e diventa attivo non appena viene configurata.',
    usersFilterAllStatus: 'Tutti gli stati',
    usersFilterAllRoles: 'Tutti i ruoli',
    usersManage: 'Gestisci',
    usersClose: 'Chiudi',
    usersNoneFound: 'Nessun utente trovato.',
    usersPagePrev: 'Precedente',
    usersPageNext: 'Successivo',
    auditTitle: 'Registro di audit',
    smtpHost: 'Host SMTP',
    smtpPort: 'Porta SMTP',
    smtpSecurity: 'Sicurezza SMTP',
    smtpUsername: 'Utente SMTP',
    smtpPassword: 'Password SMTP',
    fromEmail: 'Email mittente',
    fromName: 'Nome mittente',
    replyToEmail: 'Email di risposta',
    saveMailSettings: 'Salva configurazione della posta',
    sendTestMail: 'Invia email di prova',
    createUser: 'Crea utente',
    setPassword: 'Imposta password',
    setRoles: 'Imposta ruoli',
    setStatus: 'Imposta stato',
    resetMfa: 'Reimposta 2FA',
    revokeSessions: 'Revoca sessioni',
    filterUsers: 'Filtra utenti',
    testRecipient: 'Destinatario dell\'email di prova',
    statusConfigured: 'Configurato',
    statusMissing: 'Non configurato',
    userEmail: 'Email',
    userName: 'Nome utente',
    userRoles: 'Ruoli',
    userStatus: 'Stato',
    auditEvent: 'Evento',
    auditCreatedAt: 'Creato il',
    auditDetails: 'Dettagli',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Endpoint',
    aiGatewayIdentitySource: 'Identità dal claim del token',
    aiGatewayBudgetSource: 'Valori iniziali in',
    aiGatewayModels: 'Modelli instradati',
    aiGatewayModel: 'Modello',
    aiGatewayBackend: 'Backend',
    aiGatewayBudgets: 'Budget di token',
    aiGatewayIdentity: 'Identità',
    aiGatewayTokenBudget: 'Budget di token',
    aiGatewayWindow: 'Finestra',
    aiGatewayAnyIdentity: 'qualsiasi identità',
    aiGatewayAnyModel: 'qualsiasi modello',
    aiUsageWindowStarted: 'Finestra da',
    aiUsageRemaining: 'Residuo',
    aiUsageIdentities: 'Identità',
    aiGatewaySubtitle: 'L\'Envoy AI Gateway è l\'unica via verso un modello: i modelli instradati, i loro backend di servizio e il budget di token di ogni identità.',
    aiGatewayHint: 'I budget si gestiscono qui. Il layer di deploy si limita a inizializzare i valori per un cluster nuovo.',
    aiUsageTitle: 'Consumo IA per identità',
    aiUsageSubtitle: 'Token consumati e contabilizzati dal gateway nella finestra in corso.',
    sessionActiveUsers: 'Utenti connessi',
    sessionActiveSessions: 'Sessioni attive',
    sessionMfaSessions: 'Sessioni verificate',
    aiUsageTotalTokens: 'Token totali',
    aiServicesTitle: 'Accessi ai servizi',
    aiServicesSubtitle: 'Collegamenti alle interfacce API e operative della piattaforma; ogni destinazione verifica da sé il ruolo di amministratore.',
    aiMailSubtitle: 'Le impostazioni SMTP con cui Keycloak invia le mail di verifica e di reimpostazione, e l\'invio di prova.',
    tabOverview: 'Panoramica',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Invio e-mail',
    tabUsers: 'Utenti',
    tabAudit: 'Registro di audit',
    tabServiceLinks: 'Accessi ai servizi',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Piattaforma',
    platformTitle: 'Stato della piattaforma',
    platformSubtitle: 'Ogni workload pAIoneer Labs GmbH con le repliche pronte, i riavvii e l\'immagine, direttamente da Kubernetes.',
    platformHostPage: 'Gestisci le istanze nell\'host delle app',
    openVisitorMonitoring: 'Apri monitoraggio visitatori, marketing & SEO',
    platformUnavailable: 'Stato della piattaforma non disponibile',
    platformWorkloadsTotal: 'Workload',
    platformDegradedTotal: 'Non pronti',
    platformRestartsTotal: 'Riavvii',
    platformWorkload: 'Workload',
    platformNamespace: 'Namespace',
    platformReplicas: 'Repliche',
    platformRestarts: 'Riavvii',
    platformImage: 'Immagine',
    platformState: 'Stato',
    platformStateReady: 'Pronto',
    platformStateDegraded: 'Degradato',
    platformStateDown: 'Fermo',
    platformStateUnknown: 'Sconosciuto',
    platformNodes: 'Nodi',
    platformOsImage: 'Sistema operativo',
    platformKernel: 'Kernel',
    platformRuntime: 'Runtime dei container',
    platformKubelet: 'Kubelet',
    platformUsed: 'In uso ora',
    platformReportedCapacity: 'Riportato da Kubernetes',
    platformConfiguredCap: 'Limite configurato del container',
    platformPressure: 'Condizioni di pressione',
    platformPressureNone: 'nessuna',
    platformCpu: 'Core CPU',
    platformNoWorkloads: 'Questo namespace contiene oggetti di configurazione, nessun workload.',
    platformMemory: 'Memoria',
    platformEvents: 'Avvisi recenti',
    platformEventsNone: 'Nessun avviso.',
    platformEventObject: 'Oggetto',
    platformEventReason: 'Motivo',
    platformEventMessage: 'Messaggio',
    platformEventLastSeen: 'Visto l\'ultima volta',
    platformMetricsMissing: 'Nessun dato di consumo: metrics-server non risponde.',
    aiGatewayBackends: 'Backend di servizio',
    gpuTitle: 'Scheda grafica',
    gpuNote: 'Carico dei motori sulla scheda grafica, i token da essi prelevati per identità e per bot Webex, e i budget di token per identità e motore.',
    gpuTokensWindow: 'Token sulla scheda grafica nella finestra',
    gpuSinceStart: 'dall\'avvio del motore',
    gpuIdentities: 'Per identità, finestra in corso',
    gpuBots: 'Per bot Webex e agente, 30 giorni',
    gpuBot: 'Bot Webex / agente',
    gpuBudgetTitle: 'Budget per identità per il motore',
    gpuBudgetSet: 'Imposta budget',
    gpuBudgetHint: 'Token all\'ora sul motore; il gateway lo applica. Limita anche un\'identità senza limite.',
    gpuNoneYet: 'Ancora nulla registrato.',
    gpuEngines: 'Motori',
    gpuEngine: 'Motore',
    gpuEngineGold: 'Motore Oro',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Runtime, base di conoscenza, preparazione dell\'addestramento e tracciabilità dell\'applicazione Agentic RAG.',
    agenticRagBackendStatus: 'Stato del backend',
    agenticRagRuntimeMode: 'Modalità di esecuzione',
    agenticRagKnowledgeMode: 'Modalità conoscenza',
    agenticRagDeploymentEnv: 'Ambiente di deployment',
    agenticRagVectorStores: 'Archivi vettoriali',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Collezione documenti',
    agenticRagQdrantCuratedCollection: 'Collezione di domande e risposte curate',
    agenticRagQdrantDashboard: 'Dashboard',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Apri Swagger',
    agenticRagOpenPhoenix: 'Apri Phoenix',
    agenticRagOpenQdrant: 'Apri Qdrant',
    agenticRagKnowledgeTitle: 'Base di conoscenza',
    agenticRagKnowledgeSubtitle: 'Stato dei documenti e delle domande e risposte curate dell\'applicazione Agentic RAG.',
    agenticRagDocuments: 'Documenti',
    agenticRagCuratedQaPairs: 'Coppie domanda-risposta curate',
    agenticRagTrainingTitle: 'Preparazione dell\'addestramento',
    agenticRagTrainingSubtitle: 'L\'ultima esecuzione del generatore e l\'ultimo stato del trainer.',
    agenticRagLatestDataset: 'Ultimo dataset',
    agenticRagDatasetPairs: 'Coppie domanda-risposta',
    agenticRagDatasetDocuments: 'Documenti elaborati',
    agenticRagDatasetModifiedAt: 'Ultima modifica',
    agenticRagLatestTrainerInput: 'Ultimo input del trainer',
    agenticRagTrainerInputModifiedAt: 'Input modificato',
    agenticRagLatestTrainerRun: 'Ultima esecuzione del trainer',
    agenticRagTrainerRunModifiedAt: 'Riepilogo dell\'esecuzione modificato',
    gpuEngineSilver: 'Motore Argento',
    gpuAssignment: 'Assegnazione',
    gpuWho: 'Chi',
    gpuRank: 'Rango',
    gpuRankHint: 'Il rango 0 è servito per primo; ogni motore serve per rango.',
    gpuLanes: 'Chiamate di Veridion Core in corso per motore e rango',
    gpuInFlight: 'in corso',
    gpuWhoMainBotPeople: 'Bot principale: conversazioni con le persone',
    gpuWhoMainBotJudgements: 'Bot principale: giudizi nello stesso turno',
    gpuWhoAutopilot: 'Autopilota',
    gpuWhoAgents: 'Agenti eseguiti dal bot principale',
    gpuWhoArchitect: 'Architetto',
    gpuWhoChair: 'Presidenza della riunione',
    gpuWhoOrchestrator: 'Orchestratore dell\'istanza aziendale',
    gpuWhoColleagues: 'Colleghi IA: turni e i loro giudizi',
    gpuWhoMeetingWords: 'Colleghi IA: interventi in riunione',
    gpuWhoBackgroundReading: 'Servizio in background: lettura dei post dei bot',
    gpuWhoMemory: 'Memoria aziendale: ammissione e brief',
    gpuWhoCoding: 'Compiti di codice: giudizi e apprendimento',
    gpuWhoResearch: 'Ricerca web e OSINT',
    gpuWhoKnowledgeBase: 'Base di conoscenza aziendale: lettura delle pagine scansionate',
    gpuWhoPipeline: 'Revisione della pipeline rispetto all\'IDD',
    gpuWhoSmtm: 'Veridion SMTM: la chat e la base di conoscenza del SaaS, ultimo rango',
    gpuUnavailable: 'La scheda grafica non risponde',
    aiGatewaySource: 'Origine',
    aiSourceGpu: 'Scheda grafica',
    aiGatewayMeter: 'Contatore',
    aiGatewayMeterIdentity: 'Ogni identità, conteggiata',
    aiGatewayEngines: 'Motori sulla scheda grafica',
    aiGatewayEnginesHint: 'Valori in tempo reale di ogni motore dalle sue metriche: richieste in corso e in attesa, riempimento della cache e token serviti dall\'avvio.',
    aiEngineRunning: 'In corso',
    aiEngineWaiting: 'In attesa',
    aiEngineCache: 'Cache occupata',
    aiEngineServed: 'Token serviti',
    aiEngineIdle: 'Nessuna richiesta',
    aiEngineUnavailable: 'Il motore non risponde',
    aiGatewayServing: 'Pronto',
    aiBudgetControlTitle: 'Gestire i budget di token',
    aiBudgetControlSubtitle: 'Il budget predefinito vale per ogni identità. Una singola identità può avere un proprio limite.',
    aiBudgetDefault: 'Budget predefinito',
    aiBudgetIdentity: 'Identità',
    aiBudgetTokens: 'Token',
    aiBudgetApply: 'Applica',
    aiBudgetAdd: 'Imposta limite',
    aiBudgetRemove: 'Rimuovi',
    aiBudgetSaved: 'Budget di token applicato.',
    aiBudgetIdentityPlaceholder: 'Id client, es. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Nessun limite',
    aiBudgetSetUnlimited: 'Rimuovi il limite',
    aiBudgetRestoreLimit: 'Ripristina il limite',
    aiUsageReset: 'Svuota finestra',
    aiUsageResetDone: 'Finestra in corso svuotata.',
    userMfa: '2FA',
    userMfaOn: 'Configurata',
    userMfaOff: 'Assente',
    userCreatedAt: 'Creato',
    mailSource: 'Gestito in',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: "Nucleo conversazionale dell'assistente di trading: runtime, registro degli strumenti, server MCP e attività.",
    veridionOpenPage: 'Apri Veridion',
    veridionOpenDocs: 'Apri Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Strumenti',
    veridionToolsTitle: 'Registro degli strumenti',
    veridionToolsSubtitle: 'Mostra le famiglie di strumenti caricate e il loro stato effettivo.',
    veridionToolName: 'Strumento',
    veridionToolRuntime: 'Runtime',
    veridionToolRisk: 'Rischio',
    veridionToolEnabled: 'Attivo',
    veridionNoTools: 'Nessuno strumento Veridion caricato.',
    veridionRuntimeProfiles: 'Profili di runtime',
    veridionRegistryReloaded: 'Registro ricaricato',
    veridionProvider: 'Percorso IA',
    veridionMcpTitle: 'Server MCP',
    veridionMcpSubtitle: 'Server di strumenti esterni collegati, con stato e numero di strumenti.',
    veridionMcpServer: 'Server',
    veridionMcpState: 'Stato',
    veridionMcpTools: 'Strumenti',
    veridionMcpLastSuccess: 'Ultimo contatto',
    veridionMcpConnected: 'connesso',
    veridionMcpUnreachable: 'non raggiungibile',
    veridionMcpDisabled: 'disattivato',
    veridionMcpEmpty: 'Nessun server MCP configurato.',
    veridionActivityTitle: 'Flusso di attività',
    veridionActivitySubtitle: 'Eventi di runtime strutturati dell\'orchestratore e dei suoi strumenti.',
    veridionActivityEmpty: 'Nessuna attività registrata finora.',
    veridionActivitySource: 'Origine',
    veridionActivitySurface: 'Superficie',
    veridionActivityEvent: 'Evento',
    veridionActivityTool: 'Strumento',
    veridionActivityStatus: 'Stato',
    veridionActivitySummary: 'Riepilogo',
    veridionUnavailable: 'Veridion non è al momento disponibile.',
    veridionNotConfigured: 'Veridion non è ancora completamente configurato nel runtime della Homepage.',
    veridionRequestFailed: 'Veridion non ha completato correttamente la chiamata amministrativa richiesta.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'L\'istanza Veridion di pAIoneer Labs GmbH per i collaboratori in Webex, con YouTrack e una propria base di conoscenza; le sue chiamate ai modelli passano dall\'Envoy AI Gateway.',
    companyWorkloads: 'Carichi di lavoro',
    companyTokensWindow: 'Token nella finestra corrente',
    companyBudget: 'Budget',
    companyBudgetDefault: 'budget predefinito',
    companyCost30: 'Costo degli ultimi 30 giorni',
    openrouterTitle: 'Fatturato da OpenRouter',
    openrouterRemaining: 'Credito residuo',
    openrouterOf: 'su',
    openrouterToday: 'Oggi',
    openrouterWeek: 'Questa settimana',
    openrouterMonth: 'Questo mese',
    openrouterUnavailable: 'OpenRouter non è leggibile al momento',
    openrouterNote: 'La fatturazione di OpenRouter per la chiave della piattaforma, in dollari statunitensi; giorno e settimana in UTC. I valori registrati qui sotto contano solo le risposte che riportano il loro costo e sono quindi più bassi.',
    companyRequests30: 'Chiamate al modello degli ultimi 30 giorni',
    companyCostNote: "Costi in dollari USA come li riporta OpenRouter per richiesta; l'Envoy AI Gateway contabilizza i token sull'identità {identity}.",
    companyCostNotReported: 'non comunicato',
    companyPartUnavailable: 'non raggiungibile',
    companyWebexTitle: 'Bot Webex',
    companyWebexSubtitle: 'Webex chiama webex.paioneer-labs.eu/hook; il bridge verifica firma e mittente e passa a Veridion solo i messaggi ammessi.',
    companyWebexBot: 'Bot',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'registrato',
    companyWebexNotRegistered: 'non registrato',
    companyWebexAccess: 'Ammessi',
    companyWebexAnswered: 'Risposti',
    companyWebexRejected: 'Rifiutati',
    companyWebexFailed: 'Falliti',
    companyWebexRecent: 'Consegne recenti',
    companyWebexTime: 'Ora',
    companyWebexOutcome: 'Esito',
    companyWebexReason: 'Motivo',
    companyWebexSender: 'Mittente',
    companyWebexEmpty: "Nessuna consegna dall'ultimo avvio.",
    companyWebexNotConfigured: "Il bridge Webex non è raggiungibile oppure la sua chiave di stato manca nell'API di amministrazione.",
    companyUsageTitle: 'Utilizzo per persona',
    companyUsageSubtitle: "Chiamate al modello, token e costi degli ultimi 30 giorni dal registro di utilizzo dell'istanza.",
    companyUsagePerson: 'Persona',
    companyUsageCalls: 'Chiamate',
    companyUsageTokens: 'Token',
    companyUsageCost: 'Costo (USD)',
    companyUsageEmpty: 'Nessuna chiamata al modello negli ultimi 30 giorni.',
    companyWebexSendTitle: 'Scrivere come bot',
    companyWebexSendPerson: 'A una persona',
    companyWebexSendRoom: 'In uno spazio del bot',
    companyWebexSendEmail: 'Indirizzo e-mail in Webex',
    companyWebexSendText: 'Messaggio (Markdown)',
    companyWebexSendButton: 'Invia',
    companyWebexSendDone: 'Inviato.',
    companyWebexSendFailed: 'Non riuscito',
    companyWebexRooms: 'Spazi del bot',
    companyWebexRoomGroup: 'gruppo',
    companyWebexRoomDirect: 'diretto',
    companyWebexRoomsEmpty: 'Il bot non è ancora in nessuno spazio.',
    companyKnowledgeTitle: 'Base di conoscenza',
    companyKnowledgeSubtitle: 'I documenti della base di conoscenza dell\'istanza aziendale (Agentic RAG); l\'orchestratore li consulta quando un turno di conversazione lo richiede. Phoenix registra ogni ricerca.',
    companyKnowledgeDocument: 'Documento',
    companyKnowledgeSize: 'Dimensione',
    companyKnowledgeModified: 'Aggiunto',
    companyKnowledgeDelete: 'Rimuovi',
    companyKnowledgeDeleteConfirm: 'Rimuovere {name} dalla base di conoscenza?',
    companyKnowledgeUpload: 'Aggiungi documento',
    companyKnowledgeUploading: 'Caricamento …',
    companyKnowledgeIntake: 'Acquisizione',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'La base di conoscenza è vuota.',
    companyKnowledgeNotConfigured: "La base di conoscenza non è collegata all'API di amministrazione.",
    companyGuestsTitle: 'Ospiti con accesso',
    companyGuestsHint: 'Ogni indirizzo di {domains} può usare il bot. Gli amministratori aggiungono qui singoli indirizzi esterni; la modifica vale subito.',
    companyGuestsEmail: 'Indirizzo e-mail',
    companyGuestsAdd: 'Aggiungi',
    companyGuestsRemove: 'Rimuovi',
    companyGuestsRemoveConfirm: "Revocare a {email} l'accesso al bot?",
    companyGuestsAddedBy: 'Aggiunto da',
    companyGuestsAddedAt: 'Aggiunto il',
    companyGuestsEmpty: 'Nessun ospite inserito.',
    companyGuestsNotPersistent: "L'elenco non viene salvato: il bridge non ha una directory dati.",
    companyGuestsLoadFailed: "L'elenco salvato non era leggibile; nessun ospite ha accesso fino alla prossima modifica.",
    companyErrorRecipientNotAllowed: 'Questo indirizzo non può rispondere al bot. Aggiungilo prima come ospite, poi invia.',
    companyErrorDomainAllowed: 'Gli indirizzi di questo dominio hanno già accesso.',
    companyErrorInvalidEmail: 'Indirizzo e-mail non valido.',
    companyErrorAlreadyListed: "Questo indirizzo è già nell'elenco.",
    companyErrorStoreUnwritable: "Impossibile salvare l'elenco.",
    smtmFilterTitle: 'Filtro strumenti SMTM',
    smtmFilterSubtitle: 'Un campo vuoto mostra tutti gli strumenti; più nomi di strumento sono separati da virgola, per esempio EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Nomi degli strumenti, separati da virgola',
    smtmFilterApply: 'Applica filtro',
    smtmFilterClear: 'Azzera filtro',
    smtmReportingTitle: 'Reportistica dei segnali SMTM',
    smtmReportingSubtitle: 'Mostra i segnali di acquisto qualificati, la loro valutazione di uscita e lo stato di consegna delle notifiche automatiche.',
    smtmReportingUnavailable: 'Reportistica SMTM non disponibile',
    smtmReportingQualifiedSignals: 'Segnali qualificati',
    smtmReportingOpenSignals: 'Segnali aperti',
    smtmReportingResolvedSignals: 'Segnali chiusi',
    smtmReportingWins: 'Successi',
    smtmReportingLosses: 'Perdite',
    smtmReportingWinRate: 'Tasso di successo',
    smtmReportingAverageActualReturn: 'Rendimento reale medio',
    smtmReportingNetActualReturn: 'Rendimento reale netto',
    smtmReportingDeliveryFailed: 'Consegne fallite',
    smtmReportingEntryTime: 'Ora di ingresso',
    smtmReportingExitTime: 'Ora di uscita',
    smtmReportingExpectedReturn: 'Rendimento atteso',
    smtmReportingActualReturn: 'Rendimento reale',
    smtmReportingSignalStatus: 'Stato del segnale',
    smtmReportingNoSignals: 'Nessun segnale qualificato memorizzato finora.',
    smtmReportingPendingDeliveries: 'Consegne in sospeso',
    smtmReportingFailedDeliveries: 'Consegne fallite',
    smtmReportingDeliveryError: 'Errore di consegna',
    smtmTrainingTitle: 'Addestramento e modelli SMTM',
    smtmTrainingSubtitle: 'Mostra la qualità dell\'addestramento, lo stato dei modelli e gli artefatti pubblicati dal servizio di addestramento.',
    smtmTrainingUnavailable: 'Addestramento SMTM non disponibile',
    smtmTrainingModels: 'Modelli',
    smtmTrainingOnlineModels: 'Modelli online',
    smtmTrainingFailedModels: 'Modelli falliti',
    smtmTrainingStaleModels: 'Modelli obsoleti',
    smtmTrainingAverageMae: 'MAE medio',
    smtmTrainingAverageRmse: 'RMSE medio',
    smtmTrainingAverageR2: 'R² medio',
    smtmTrainingAverageMase: 'MASE medio',
    smtmTrainingAverageHitRate: 'Direzione corretta media',
    smtmTrainingHitRate: 'Direzione corretta',
    smtmTrainingLastSuccess: 'Ultimo addestramento riuscito',
    smtmTrainingResolution: 'Risoluzione / orizzonte',
    smtmTrainingConsoleTitle: 'Console di addestramento SMTM',
    smtmTrainingConsoleSubtitle: 'Tail in tempo reale dell\'output del servizio di addestramento.',
    smtmTrainingConsoleUnavailable: 'Console di addestramento SMTM non disponibile',
    smtmTrainingConsoleEmpty: 'Nessun output di addestramento disponibile.',
    smtmRuntimeTitle: 'Runtime SMTM',
    smtmRuntimeSubtitle: 'Orizzonte globale, stato di ricostruzione e cancello di previsione del sistema SMTM in esercizio.',
    smtmRuntimeUnavailable: 'Runtime SMTM non disponibile',
    smtmRuntimeForecastHorizon: 'Orizzonte di previsione',
    smtmRuntimeResolution: 'Risoluzione',
    smtmRuntimeConfigVersion: 'Versione di configurazione',
    smtmRuntimePredictionGate: 'Cancello di previsione',
    smtmRuntimeRebuild: 'Ricostruzione',
    smtmRuntimeStateOpen: 'aperto',
    smtmRuntimeStateClosed: 'chiuso',
    smtmRuntimeStateActive: 'attiva',
    smtmRuntimeStateIdle: 'inattiva',
    smtmRuntimeForecastHorizonMinutes: 'Minuti dell\'orizzonte di previsione',
    smtmRuntimeResolutionMinutes: 'Minuti di risoluzione',
    smtmRuntimeRequireCompletedBars: 'Richiedi barre complete',
    smtmRuntimePredictionGateOpen: 'Cancello di previsione aperto',
    smtmRuntimeRebuildActive: 'Ricostruzione attiva',
    smtmRuntimeSaving: 'Salvataggio del runtime...',
    smtmRuntimeSave: 'Salva impostazioni del runtime',
    smtmRuntimeReset: 'Annulla modifiche del runtime',
    smtmRuntimeSaved: 'Impostazioni del runtime SMTM salvate.',
    smtmTrainingRows: 'Righe di addestramento / test',
    smtmTrainingMetrics: 'Metriche',
    smtmTrainingIssues: 'Problemi di addestramento',
    smtmTrainingLlmFeatures: 'Caratteristiche LLM',
    smtmTrainingNoModels: 'Nessun modello di addestramento in cache.',
    smtmDirection: 'Direzione',
    smtmSentiment: 'Sentiment',
    smtmDeliveryStage: 'Fase',
    smtmDeliveryRecipient: 'Destinatario',
    mailSettingsSaved: 'Configurazione della posta salvata.',
    mailTestSent: 'Email di prova inviata.',
    userCreatedSuccess: 'Utente creato correttamente.',
    userUpdatedSuccess: 'Utente aggiornato correttamente.',
    userDeletedSuccess: 'Utente eliminato correttamente.',
    deleteUser: 'Elimina utente',
    roleLabels: {
      admin: 'Amministratore',
      pro: 'Pro',
      tester: 'Tester',
      user: 'Utente'
    },
    statusLabels: {
      pending_email_verification: 'Verifica email in sospeso',
      pending_mfa: '2FA in sospeso',
      active: 'Attivo',
      locked: 'Bloccato',
      disabled: 'Disattivato'
    }
  },
  footer: {
    managingDirectors: 'Amministratori delegati',
    servicesTitle: 'Servizi',
    legal: {
      title: 'Informazioni legali',
      imprint: 'Note legali',
      privacy: 'Informativa sulla privacy',
      aiTransparency: 'Trasparenza sull’IA',
      cookieSettings: 'Impostazioni dei cookie',
      terms: 'Termini di servizio'
    },
    copyright: 'Tutti i diritti riservati.'
  },
  auth: {
    validating: 'Validazione in corso...',
    errors: {
      registrationFailed: 'Registrazione non riuscita: ',
      unknownError: 'Errore sconosciuto'
    }
  },
  account: {
    username: 'Nome utente',
    email: 'E-mail',
    roles: 'Ruoli',
    manageText: 'Password, autenticazione a due fattori, sessioni attive e indirizzo e-mail si modificano nella gestione dell\'account.',
    manageButton: 'Apri la gestione dell\'account',
    signedOut: 'Non hai effettuato l\'accesso.'
  },
  cookies: {
    title: 'Impostazioni sulla privacy',
    description: 'Analizziamo le statistiche di visita con metodi di apprendimento automatico per migliorare il nostro sito web. Con il tuo consenso trattiamo a tal fine dati di utilizzo e del dispositivo, compreso il tuo indirizzo IP, e riconosciamo il tuo browser nelle visite successive. Il consenso è facoltativo e può essere revocato in qualsiasi momento in «{settings}». I dettagli, anche sui trasferimenti verso paesi terzi, sono nell’informativa sulla privacy.',
    necessary: {
      title: 'Necessari',
      description: 'Indispensabili per il funzionamento del sito, ad esempio la scelta della lingua e il salvataggio di questa selezione.'
    },
    statistics: {
      title: 'Statistiche',
      description: 'Pagine visitate e utilizzo del sito, senza riconoscimento e senza memorizzare l’indirizzo IP.'
    },
    marketing: {
      title: 'Analisi e apprendimento automatico',
      description: 'Riconoscimento nelle visite successive e analisi dell’indirizzo IP (posizione approssimativa, operatore di rete, organizzazione) e delle caratteristiche del dispositivo; conservazione fino a dodici mesi dopo l’ultima visita. In tal modo il tuo indirizzo IP viene trasmesso anche a registri Internet negli USA, in Australia e a Mauritius, per i quali non è stato accertato un livello adeguato di protezione dei dati; sussiste il rischio di un accesso da parte delle autorità di tali paesi e di una maggiore difficoltà nel far valere i tuoi diritti.'
    },
    acceptAll: 'Accetta tutto',
    rejectAll: 'Solo necessari',
    settings: 'Impostazioni',
    save: 'Salva selezione',
    alwaysOn: 'Sempre attivi'
  },
  pages: {
    teaching: {
      hero: { title: 'Formazione su Edge AI ed EU AI Act', subtitle: 'Consulenza IA per le imprese • Sviluppo edge • Implementazione a norma di legge' },
      intro: 'Formazione specializzata sull\'IA per la direzione aziendale, i responsabili di progetto e i team di sviluppo. Dalla consulenza strategica all\'implementazione tecnica – in conformità all\'EU AI Act.',
      eu_ai_act: {
        title: 'Conformità all\'EU AI Act ed edge computing',
        subtitle: 'Implementazione dell\'IA a norma di legge con elaborazione locale dei dati',
        description: 'L\'EU AI Act stabilisce regole rigorose per l\'impiego dell\'intelligenza artificiale in Europa. L\'edge computing offre la soluzione ideale: i dati sensibili restano in locale, la conformità si semplifica e il controllo sui sistemi di IA rimane nelle tue mani.',
        benefits: ['Protezione dei dati grazie all\'elaborazione locale', 'Minore complessità della conformità', 'Pieno controllo sulle decisioni dell\'IA', 'Trasparenza e tracciabilità', 'Rischi legali ridotti al minimo', 'Indipendenza dai fornitori di servizi cloud'],
        highlight: 'Edge computing + EU AI Act = IA a norma di legge, senza compromessi'
      },
      offerings: {
        title: 'Offerta formativa',
        categories: [
          { title: 'Intelligenza artificiale e machine learning', icon: 'brain', topics: ['IA generativa e Large Language Model (edge e cloud)', 'Machine learning classico (ottimizzato per l\'edge)', 'Deep learning e reti neurali (deployment su edge)', 'Computer vision e NLP (soluzioni adatte all\'edge)', 'Sistemi RAG e fine-tuning di LLM (edge e cloud)', 'Agenti IA autonomi (edge computing)', 'Conformità all\'EU AI Act e certezza del diritto'] },
          { title: 'Data science e statistica', icon: 'chart', topics: ['Statistica descrittiva e inferenziale', 'Modellazione e analisi dei dati', 'Analisi di serie temporali', 'Econometria per economia aziendale ed economia politica', 'Biostatistica per le scienze naturali', 'A/B testing e progettazione degli esperimenti'] },
          { title: 'Architettura software e sicurezza', icon: 'shield', topics: ['Architetture modulari', 'Accoppiamento debole e clean code', 'Progettazione di microservizi', 'Sicurezza informatica e conformità', 'DevOps e CI/CD', 'Architetture cloud'] }
        ]
      },
      target_groups: {
        title: 'Destinatari',
        groups: [
          { title: 'Direzione aziendale e decisori', description: 'Consulenza strategica sull\'IA, analisi dei costi e decisioni di investimento', formats: ['Executive briefing', 'Analisi del ROI', 'Consulenza strategica'], focus: 'Business case, conformità all\'EU AI Act, pianificazione del budget' },
          { title: 'Responsabili di progetto e manager', description: 'Gestione dei progetti di IA, scelta delle tecnologie e strategie di implementazione', formats: ['Workshop per il management', 'Valutazioni tecnologiche', 'Sviluppo della roadmap'], focus: 'Pianificazione dei progetti, selezione dei fornitori, gestione del rischio' },
          { title: 'Sviluppatori e ingegneri IT', description: 'Sviluppo pratico di soluzioni edge AI, implementazione tecnica e deployment', formats: ['Approfondimenti tecnici', 'Code review', 'Workshop di architettura'], focus: 'Edge computing, fine-tuning di LLM, integrazione di sistemi' },
          { title: 'Collaboratori dei reparti specialistici', description: 'Comprensione dell\'IA, tecniche di prompting e applicazione pratica nel lavoro quotidiano', formats: ['Formazione per gli utenti', 'Workshop di prompting', 'Sviluppo di casi d\'uso'], focus: 'Applicazione pratica, integrazione nei flussi di lavoro, aumento della produttività' },
          { title: 'Studenti e accademici', description: 'Didattica universitaria, ripetizioni e supervisione di progetti scientifici', formats: ['Lezioni', 'Tutoraggio', 'Supervisione di tesi'], focus: 'Statistica, econometria, metodi di ricerca' }
        ]
      },
      expertise: {
        title: 'Competenze tecniche',
        items: ['Sviluppo di roadmap strategiche per l\'IA nelle imprese', 'Sistemi edge AI con architetture RAG/GRAG e fine-tuning LoRA/QLoRA', 'Strategie di conformità all\'EU AI Act e implementazione a norma di legge', 'Analisi del ROI e pianificazione degli investimenti per i progetti di IA', 'Agenti IA autonomi con set di strumenti e capacità di ragionamento', 'Change management per l\'adozione dell\'IA nelle organizzazioni', 'Strategie cloud e on-premises (Azure, STACKIT)', 'Prompt engineering e ottimizzazione dei flussi di lavoro']
      },
      technologies: { title: 'Stack tecnologico', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' },
      clients: { title: 'Settori e istituzioni', sectors: ['Assicurazioni sanitarie', 'Editoria', 'Banche e fintech', 'Industria e IoT', 'Ricerca e università', 'Consulenza', 'Startup'] },
      workshops: {
        title: 'Formati disponibili',
        formats: [
          { title: 'Executive briefing', duration: '2-4 ore', description: 'Panoramica strategica per la direzione aziendale, con attenzione al ROI e all\'EU AI Act' },
          { title: 'Workshop per il management', duration: '1-2 giorni', description: 'Formazione per i responsabili di progetto su implementazione dell\'IA e change management' },
          { title: 'Approfondimento tecnico', duration: '2-5 giorni', description: 'Sviluppo pratico di soluzioni edge AI per team IT e ingegneri' },
          { title: 'Formazione per gli utenti', duration: '0,5-1 giorno', description: 'Applicazione pratica dell\'IA per i collaboratori dei reparti specialistici' },
          { title: 'Coaching individuale', duration: 'Secondo necessità', description: 'Affiancamento personale e supporto ai progetti' }
        ]
      },
      sidebar: {
        languagesLabel: 'Lingue:',
        languagesValue: 'DE / EN / NL',
        focusLabel: 'Focus:',
        specializationTitle: 'Specializzazione',
        specializationItems: ['Edge AI per l\'elaborazione locale dei dati senza dipendenza dal cloud', 'Implementazione conforme all\'EU AI Act per la certezza del diritto'],
        benefitsTitle: 'Vantaggi',
        benefits: ['Su misura per i destinatari', 'Subito applicabile', 'Orientato al ROI', 'Da remoto o in sede']
      },
      cta: {
        title: 'Tutto pronto per una trasformazione strategica con l\'IA?',
        description: 'Dalla consulenza per la direzione aziendale all\'implementazione tecnica: parliamo delle tue esigenze specifiche.',
        button: 'Richiedi una consulenza',
        email: 'info@paioneer.eu',
        subject: 'Richiesta di formazione'
      }
    },
    agenticdev: {
      seo: {
        title: 'Intent-Driven Development (IDD) per l\'agentic coding | pAIoneer Labs GmbH',
        description: 'L\'Intent-Driven Development rende governabile lo sviluppo software assistito dall\'IA: significato, decisioni e scenari diventano artefatti operativi per l\'agentic coding.',
        keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, sviluppo software agentico, sviluppo software assistito dall\'IA, Vibe Coding, Spec-Driven Development, Prompt Engineering, ingegneria dei requisiti con l\'IA',
        ogTitle: 'Intent-Driven Development: il significato prima dell\'implementazione',
        ogDescription: 'L\'IDD rende operativo il contesto prima che il codice venga scritto: intent, decisioni e scenari diventano la memoria di progetto dello sviluppo software agentico.',
        twitterTitle: 'Intent-Driven Development (IDD) per l\'agentic coding',
        twitterDescription: 'Codice governabile invece del caos dei prompt: l\'IDD trasforma significato, decisioni e scenari in artefatti operativi.',
        url: 'https://paioneer-labs.eu/agenticdev',
        structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) per l\'agentic coding', serviceType: 'Sviluppo software agentico e processi di sviluppo assistiti dall\'IA', description: 'Consulenza e realizzazione per Intent-Driven Development, IDD Vault, flussi di lavoro di agentic coding e sviluppo software assistito dall\'IA e verificabile.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' }
      },
      hero: { eyebrow: 'L\'agentic coding ha bisogno di un contesto esplicito', title: 'Intent-Driven Development', claim: 'Il significato prima dell\'implementazione.', lead: 'L\'IA scrive codice. L\'IDD fa sì che lavori al problema giusto. L\'Intent-Driven Development trasforma obiettivi, confini, decisioni e scenari in artefatti operativi per lo sviluppo software agentico.' },
      implicitContextProblem: { title: 'Il rischio è il contesto implicito', intro: 'Il vero rischio dello sviluppo software assistito dall\'IA non è il codice che manca. Il rischio è il contesto che resta nascosto nella testa di qualcuno, nella cronologia di una chat o in ticket sparsi.', items: [{ title: 'Incarico poco chiaro', description: 'I prompt descrivono spesso una soluzione, ma non l\'obiettivo, i non-obiettivi, i criteri di successo e le ipotesi. L\'IA lavora allora velocemente, ma non necessariamente nella direzione giusta.' }, { title: 'Architettura casuale', description: 'Le decisioni tecnologiche vengono prese di sfuggita: persistenza dei dati, scelta del modello, casi di errore ed esercizio vengono decisi implicitamente, anziché essere guidati consapevolmente.' }, { title: 'Risultato non verificabile', description: 'Senza scenari e criteri di accettazione resta incerto se il codice si comporti davvero correttamente o sembri soltanto plausibile.' }], resolution: 'L\'IDD risolve esattamente questo problema: prima si rende operativo il significato, poi da esso si deriva il codice.' },
      antiVibeCoding: { title: 'Il vibe coding non è un processo di sviluppo', description: 'Per le demo l\'istinto può bastare. Per un software che comporta esercizio, manutenzione, sicurezza, costi e responsabilità non basta. Agli agenti non servono più sensazioni, ma un contesto esplicito.', contrasts: ['Il vibe coding genera movimento. L\'IDD genera direzione.', 'Il prompting genera risposte. L\'IDD genera memoria di progetto.', 'L\'agentic coding senza IDD resta attività. L\'agentic coding con l\'IDD diventa sviluppo governabile.'] },
      principle: { title: 'La documentazione non è un sottoprodotto', thesis: 'Nell\'IDD la documentazione è un artefatto operativo.', description: 'La documentazione non serve a fare rapporto. È lo spazio di lavoro in cui obiettivi, confini, decisioni e comportamento atteso diventano espliciti prima che gli agenti implementino.', pillarsTitle: 'Intent. Decisioni. Scenari. Codice.', pillarsIntro: 'L\'IDD non riduce lo sviluppo software a una serie di prompt. Rende esplicito il significato di un progetto e ne deriva un\'implementazione verificabile.', pillars: [{ title: 'Intent', description: 'Che cosa si vuole ottenere, che cosa è espressamente escluso e da che cosa riconosciamo il successo?' }, { title: 'Decisioni', description: 'Quali decisioni importanti sono state prese, in quale contesto e con quali conseguenze?' }, { title: 'Scenari', description: 'Quale comportamento ci si aspetta nei casi normali, nei casi limite, nei casi di errore e nelle situazioni di accettazione?' }, { title: 'Codice', description: 'L\'implementazione nasce dal significato documentato e viene verificata rispetto agli scenari e ai controlli previsti.' }] },
      vault: { title: 'L\'IDD Vault: memoria di progetto invece della cronologia dei prompt', description: 'L\'IDD Vault conserva il contesto rilevante là dove agenti e persone possono riutilizzarlo. Non più file del necessario. Ogni file ha una funzione chiara.', rule: 'Pochi artefatti. Funzione chiara. Contesto duraturo.', effect: 'Il Vault impedisce che il contesto decisivo si perda nella chat, nella testa di qualcuno o in ticket sparsi.', treeLines: ['/project', '  /idd_vault', '    intent.md       # obiettivo, non-obiettivi, criteri di successo, ipotesi', '    decisions.md    # decisioni con contesto, motivazione, conseguenze', '    scenarios.md    # comportamento, casi limite, criteri di accettazione', '  /code', '  AGENTS.md         # regole e aspettative per gli agenti di codice', '  README.md         # punto di ingresso, setup, modalità operativa, confini'] },
      outputs: { title: 'Non testo. Codice governabile.', description: 'I file IDD non sono una relazione. Sono l\'input per un lavoro di implementazione concreto e per riportare nel progetto ciò che si è appreso.', items: [{ file: 'intent.md', result: 'Ambito', description: 'Endpoint, modello dei dati, criteri di successo, non-obiettivi e ipotesi diventano visibili come quadro di riferimento dello sviluppo.' }, { file: 'decisions.md', result: 'Architettura', description: 'Tecnologia, esercizio, persistenza, scelta del modello e compromessi vengono motivati invece di essere decisi di sfuggita.' }, { file: 'scenarios.md', result: 'Test', description: 'Test di accettazione, casi di errore, transizioni di stato e casi limite emergono prima o durante l\'implementazione.' }, { file: 'AGENTS.md', result: 'Qualità del codice', description: 'Regole, pattern, vincoli, migrazioni, OpenAPI e output attesi diventano espliciti per gli agenti.' }, { file: 'README.md', result: 'Punto di ingresso', description: 'Setup, modalità operativa, confini ed esempi di flusso restano comprensibili per persone e agenti.' }, { file: 'Code', result: 'Ciclo di feedback', description: 'Quanto emerge dall\'implementazione e dalla verifica rifluisce nel Vault, nei test e nell\'iterazione successiva.' }] },
      comparison: { title: 'L\'IDD inizia prima della specifica', intro: 'Lo Spec-Driven Development è efficace quando l\'obiettivo è già tecnicamente preciso e stabile. L\'IDD interviene prima: là dove dominio, ipotesi, compromessi e casi di errore devono ancora essere resi espliciti.', columns: ['Approccio', 'Fulcro', 'Punto di forza', 'Limite'], rows: [{ approach: 'Prompting', center: 'Input a un modello', strength: 'Rapido e diretto', limit: 'Effimero, incompleto e difficile da verificare' }, { approach: 'Vibe Coding', center: 'Istinto e iterazione', strength: 'Utile per sperimentazioni e demo', limit: 'Nessun controllo affidabile per un software di cui si deve rispondere' }, { approach: 'Spec-Driven Development', center: 'Contratto tecnico', strength: 'Coerenza rispetto a una specifica già definita', limit: 'Il problema sbagliato può essere implementato in modo formalmente corretto' }, { approach: 'Intent-Driven Development', center: 'Significato, obiettivo e decisioni', strength: 'Chiarisce contesto, compromessi e confini prima dell\'implementazione', limit: 'Richiede una cura disciplinata del contesto e della validazione' }], summary: 'Le specifiche dicono che cosa deve valere sul piano tecnico. L\'IDD motiva perché va costruita proprio questa direzione.' },
      workflow: { title: 'Chiarire. Decidere. Formulare. Costruire. Riportare.', description: 'L\'IDD non è un modello a cascata. L\'IDD è un\'iterazione piccola e controllata, con un contesto duraturo.', steps: [{ title: 'Chiarire l\'intent', description: 'Obiettivi, non-obiettivi, criteri di successo e ipotesi diventano visibili prima che il codice venga scritto.' }, { title: 'Documentare le decisioni', description: 'Le decisioni di architettura e di prodotto vengono registrate con contesto, motivazione e conseguenze.' }, { title: 'Formulare gli scenari', description: 'Comportamento normale, casi limite, casi di errore e criteri di accettazione vengono descritti in forma verificabile.' }, { title: 'Far implementare gli agenti', description: 'Gli agenti IA lavorano a partire da un contesto esplicito anziché da prompt isolati.' }, { title: 'Verificare e riportare i risultati', description: 'Quanto emerge da codice, test ed esercizio aggiorna il Vault e l\'iterazione successiva.' }] },
      impact: { title: 'Perché conta nei progetti reali', description: 'L\'IDD rende lo sviluppo assistito dall\'IA integrabile nel lavoro dei team, nell\'esercizio e nella garanzia della qualità.', items: ['Meno rilavorazioni, perché obiettivi e non-obiettivi sono visibili.', 'Architettura migliore, perché le decisioni sono motivate.', 'Test migliori, perché gli scenari nascono prima del codice.', 'Collaborazione migliore, perché il contesto non si perde nella chat.', 'Risultati migliori dagli agenti, perché ogni passo si basa su artefatti espliciti.'] },
      contact: { title: 'Portare l\'IDD nei processi di sviluppo agentico', description: 'Se lo sviluppo assistito dall\'IA deve essere più di un esperimento, ha bisogno di un modello di contesto operativo.', details: 'Offriamo supporto nella creazione di IDD Vault, regole per gli agenti, scenari e flussi di sviluppo verificabili.', button: 'Parliamo di IDD', subject: 'Parliamo di Intent-Driven Development', email: 'info@paioneer.eu' }
    },
    impressum: injectPersonalData('it', baseTranslationIT)
  }
};
